webpackJsonp([1],{

/***/ "+KaG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{attrs:{"type":_vm.type},on:{"click":_vm.openDemoForm}},[_vm._v(_vm._s(_vm.title))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+Rk1":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;

/***/ }),

/***/ "+rzM":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),

/***/ "/03a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Row',{staticStyle:{"margin-bottom":"64px"},attrs:{"type":"flex","justify":"space-around","align":"middle"}},[_c('Col',{attrs:{"span":"24"}},[_c('Hero',{attrs:{"title":"Vue Finance - Pricing","minHeight":"500px","backgroundColor":"#2c3849","description":"We’ll deliver the critical reports and insights needed to grow your net worth, whether you’re an everyday investor or a single family office."}}),_vm._v(" "),_c('Row',{staticClass:"section",attrs:{"type":"flex","justify":"center"}},[_c('Col',{staticClass:"info-section-col"},[_c('h2',[_vm._v("Features Included in All Plans")]),_vm._v(" "),_c('h3',[_c('Icon',{staticClass:"green",attrs:{"type":"checkmark-round"}}),_c('span',{},[_vm._v(" Access to 14,000+ Integrations ")])],1),_vm._v(" "),_c('h3',[_c('Icon',{staticClass:"green",attrs:{"type":"checkmark-round"}}),_c('span',{},[_vm._v(" Custom Assessments and Reporting ")])],1),_vm._v(" "),_c('h3',[_c('Icon',{staticClass:"green",attrs:{"type":"checkmark-round"}}),_c('span',{},[_vm._v(" Custom Asset Valuations ")])],1),_vm._v(" "),_c('h3',[_c('Icon',{staticClass:"green",attrs:{"type":"checkmark-round"}}),_c('span',{},[_vm._v(" Custom Portfolio Values and KPIs ")])],1),_vm._v(" "),_c('h3',[_c('Icon',{staticClass:"green",attrs:{"type":"checkmark-round"}}),_c('span',{},[_vm._v(" Nested Accounts ")])],1),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'Features' }}},[_c('Button',{staticClass:"primary",attrs:{"type":"text"}},[_vm._v("See All Features "),_c('Icon',{attrs:{"type":"arrow-right-c"}})],1)],1)],1),_vm._v(" "),_c('Col',{staticClass:"info-section-col"},[_c('h2',[_vm._v("Frequently Asked Questions")]),_vm._v(" "),_vm._l((_vm.faqs),function(item,$index){return _c('Row',{key:$index},[_c('Poptip',{attrs:{"placement":"bottom","title":item.question,"content":item.answers.join(' ')}},[_c('a',[_c('h3',[_c('Icon',{attrs:{"type":"information-circled"}}),_vm._v(" "+_vm._s(item.question))],1)])])],1)})],2)],1),_vm._v(" "),_c('Row',{staticClass:"section",attrs:{"type":"flex","justify":"center","align":"middle"}},[_c('h2',{staticStyle:{"text-align":"center","font-size":"1.6rem"}},[_c('Icon',{staticClass:"green",staticStyle:{"font-size":"1.6rem","padding":"8px"},attrs:{"type":"arrow-right-c"}}),_c('span',{staticClass:"underline"},[_vm._v("14-Day free trial")]),_vm._v(" for all plans. "),_c('span',{staticClass:"underline"},[_vm._v("Cancel any time")]),_vm._v(".")],1)]),_vm._v(" "),_c('Row',{staticClass:"section",attrs:{"type":"flex","justify":"center","align":"middle"}},_vm._l((_vm.pricingPlans),function(plan,$index){return _c('PricingPlanCard',{key:$index,attrs:{"buttonType":"primary","plan":plan,"showAnnual":_vm.showAnnual},on:{"show-annual-toggle":function($event){_vm.showAnnual = !_vm.showAnnual}}})})),_vm._v(" "),_c('Row',{attrs:{"type":"flex","justify":"center"}},[_c('Col',{staticStyle:{"margin":"0 32px","width":"750px"}},[_c('Card',[_c('Row',{staticStyle:{"margin-bottom":"8px","padding":"0 0px"},attrs:{"type":"flex","justify":"center"}},[_c('h2',[_vm._v("Enterprise Pricing")]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("For family offices, wealth managers, estate managers, and other enterprises needing high-performing software to fit all of your company’s reporting and management needs.")])]),_vm._v(" "),_c('Row',{attrs:{"type":"flex","justify":"center"}},[_c('ScheduleButton',{staticStyle:{"margin":"4px 4px"},attrs:{"type":"primary","title":"Schedule Demo","eventType":"demo","isMobile":_vm.isMobile}}),_vm._v(" "),_c('ScheduleButton',{staticStyle:{"margin":"4px 4px"},attrs:{"type":"default","title":"Schedule a Call","eventType":"introductory-call","isMobile":_vm.isMobile}})],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/6mk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var pricingPlans = [{
  title: 'Personal',
  tier: 1,
  monthlyPrice: '$29',
  annualPrice: '$24',
  description: 'For investors needing to centralize and visualize their widespread portfolio.',
  features: [{ title: 'Accounts', quantity: 10, enabled: true }, { title: 'Integrations', quantity: 5, enabled: true }, { title: 'Assessments', quantity: 15, enabled: true }, { title: 'Collaborators', quantity: null, enabled: false }, { title: 'Multiple Portfolios', quantity: null, enabled: false }]
}, {
  title: 'Professional',
  tier: 2,
  monthlyPrice: '$89',
  annualPrice: '$79',
  description: 'For sophisticated investors needing mission critical insights on their data to make informed investment decisions.',
  features: [{ title: 'Accounts', quantity: 30, enabled: true }, { title: 'Integrations', quantity: 15, enabled: true }, { title: 'Assessments', quantity: 40, enabled: true }, { title: 'Collaborators', quantity: null, enabled: false }, { title: 'Multiple Portfolios', quantity: null, enabled: false }]
}, {
  title: 'Advanced',
  tier: 3,
  monthlyPrice: '$599',
  annualPrice: '$499',
  description: 'For high net worth individuals needing an all-in-one portfolio management suite for custom reporting across all asset classes and entities.',
  features: [{ title: 'Accounts', quantity: 200, enabled: true }, { title: 'Integrations', quantity: 25, enabled: true }, { title: 'Assessments', quantity: 300, enabled: true }, { title: 'Collaborators', quantity: null, enabled: true }, { title: 'Multiple Portfolios', quantity: null, enabled: true }]
}];

/* harmony default export */ __webpack_exports__["a"] = (pricingPlans);

/***/ }),

/***/ "/JsO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{staticClass:"pricing-plan-card"},[_c('Row',{staticClass:"plan-card-header",attrs:{"type":"flex","justify":"center"}},[_c('h2',[_vm._v(_vm._s(_vm.plan.title))])]),_vm._v(" "),_c('Row',{attrs:{"type":"flex","justify":"center","align":"middle"}},[_c('i',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.plan.description))])]),_vm._v(" "),_c('Row',{attrs:{"type":"flex","justify":"center","align":"middle"}},[_c('h1',{staticClass:"price"},[_vm._v(_vm._s(_vm.showAnnual ? _vm.plan.annualPrice : _vm.plan.monthlyPrice)+" "),_c('span',{staticClass:"light-grey-text",staticStyle:{"font-size":"16px"}},[_vm._v("/month")])])]),_vm._v(" "),_c('Row',{attrs:{"type":"flex","justify":"center","align":"middle"}},[_c('h4',{staticClass:"increment light-grey-text"},[_c('a',{staticClass:"light-grey-text",on:{"click":function($event){_vm.$emit('show-annual-toggle');}}},[_vm._v("\n        "+_vm._s(_vm.showAnnual ? 'Paid Annually' : 'Paid Monthly')+" "),_c('Icon',{attrs:{"type":"loop"}})],1)])]),_vm._v(" "),_c('Row',{staticStyle:{"padding-bottom":"16px"},attrs:{"type":"flex","justify":"start","align":"middle"}},[_c('Col',{staticStyle:{"padding":"0 16px"},attrs:{"span":"24"}},_vm._l((_vm.plan.features),function(feature,$index){return _c('Row',{key:$index,attrs:{"type":"flex","justify":"start"}},[_c('span',[_c('Icon',{class:feature.enabled ? 'green' : 'grey-icon',attrs:{"type":feature.enabled ? 'checkmark-round' : 'close-round'}}),_vm._v(" "+_vm._s(feature.quantity)+" "+_vm._s(feature.title)+" \n          "),(_vm.faqs[$index])?_c('Poptip',{attrs:{"placement":"bottom","title":_vm.faqs[$index].question,"content":_vm.faqs[$index].answers[0]}},[_c('a',{staticClass:"light-grey-text"},[_c('h5',[_c('Icon',{attrs:{"type":"information-circled"}})],1)])]):_vm._e()],1)])}))],1),_vm._v(" "),_c('Row',{attrs:{"type":"flex","justify":"center","align":"middle"}},[_c('a',{staticClass:"nav-item",attrs:{"href":_vm.buildUrl(_vm.plan)}},[_c('Button',{staticClass:"green-btn",attrs:{"type":"primary","href":_vm.buildUrl(_vm.plan)}},[_c('strong',[_vm._v("Start Free Trial")]),_vm._v(" "),_c('Icon',{attrs:{"type":"arrow-right-c"}})],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/Qhs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{style:({ width: _vm.isMobile ? '300px' : '350px' })},[_c('CardHeader',{key:"brokerage",attrs:{"slot":"title","title":"Net Worth Growth"},slot:"title"}),_vm._v(" "),_c('Row',{staticClass:"feature-card",attrs:{"type":"flex","justify":"center","align":"middle"}},[_c('ChangeIndicatorTable',{staticStyle:{"height":"100%","width":"100%"},attrs:{"tableData":_vm.tableData,"baseValue":_vm.baseValue}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/c8C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var pricingFAQs = [{
  question: 'What is considered an Account?',
  answers: ['An Account is any asset, liability, or entity added to your portfolio.\n      ', '\n      An account could be a Checking Account, a 401(k), a Business, a Real Estate Property, and a Mortgage, etc.\n      ', '\n        Nested Accounts are considered in your pricing plan. If have an account, such as Business, with a sub account, such as a business checking account, it would be recognized as two accounts.\n      ']
}, {
  question: 'What is an Integration?',
  answers: ['\n      Integrations provide connections to external data sources in order to retrieve values related to your portfolio.\n      ', '\n      You can use these values in account valuations, assessments, and other features.\n      ', '\n        For example, you may want to retrieve an estimate for a real estate property in your portfolio and use that value as the valuation. You would enable the Zillow integration and reference the Zestimate in your valuation for that account.\n      ']
}, {
  question: 'What is an Assessment?',
  answers: ['\n      Assessments are custom, real-time reports created to visualize important pieces of your portfolio. These charts will automatically be updated as values in your portfolio change.\n\n      ', '\n        For example, you can create an Assessment that generates a line chart plotting your net worth over the last twelve months or a pie chart showing your portfolio distribution based on different investment sectors.\n      ']
}];

/* harmony default export */ __webpack_exports__["a"] = (pricingFAQs);

/***/ }),

/***/ "/p5N":
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__("+rzM").parseFloat
  , $trim       = __webpack_require__("gZvG").trim;

module.exports = 1 / $parseFloat(__webpack_require__("qTrL") + '-0') !== -Infinity ? function parseFloat(str){
  var string = $trim(String(str), 3)
    , result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;

/***/ }),

/***/ "0ZDD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Hero__ = __webpack_require__("UfZ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DenseContent__ = __webpack_require__("1uhW");
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Hero: __WEBPACK_IMPORTED_MODULE_0__Hero__["a" /* default */], DenseContent: __WEBPACK_IMPORTED_MODULE_1__DenseContent__["a" /* default */] },
  data: function data() {
    return {
      terms: [{
        title: 'Terms of Use',
        content: ['Last updated: September 6, 2018']
      }, {
        title: 'General',
        content: ['Please read these Terms and Conditions ("Terms", "Terms and Conditions") carefully before using the vuefinance.com website (the "Service") owned and operated by Vue Finance, Inc. ("us", "we", or "our").', 'Your access to and use of the Service is conditioned upon your acceptance of and compliance with these Terms. These Terms apply to all visitors, users and others who wish to access or use the Service.', 'By accessing or using the Service you agree to be bound by these Terms. If you disagree with any part of the terms then you do not have permission to access the Service.']
      }, {
        title: 'Ownership',
        content: ['The Service, including the information, text, graphics, images, illustrations and other content contained therein, are owned by Vue Finance, Inc. or our licensors or third party vendors (together, “Third Party Service Providers”) and are protected under both United States and foreign laws. Except as explicitly stated in these Terms, all rights in and to the Service are reserved by us or our Third Party Service Providers.']
      }, {
        title: 'Limited License',
        content: ['Subject to your compliance with these Terms, you are hereby granted a limited, non-exclusive, non-transferable, non-sublicensable, revocable license to access and use the Service for your own personal, non-commercial use. Any use of the Service other than as specifically authorized herein, without our prior written permission, is strictly prohibited, will terminate the license granted herein and violate the intellectual property rights of Vue Finance, Inc. and its Third Party Service Providers. We reserve the right to modify the Service or to suspend or stop providing all or portions of the Service at any time. You also have the right to stop using the Service at any time.']
      }, {
        title: 'User Accounts',
        content: ['When you create a user account with us, you guarantee that you are above the age of 18, and that the information you provide us is accurate, complete, and current at all times. Inaccurate, incomplete, or obsolete information may result in the immediate termination of your user account on the Service.', 'You authorize us to make any inquiries we consider necessary to validate your identity. These inquiries may include asking you for further information, requiring you to provide your full address, your date of birth, your social security number and/or requiring you to take steps to confirm ownership of your email address or financial instruments, ordering a credit report, or verifying information you provide against third party databases or through other sources. If you do not provide this information for the purpose of validating your identity or Vue Finance, Inc. cannot verify your identity, we can refuse to allow you to use the Services.', 'You are responsible for maintaining the confidentiality and security of your email address, username, password and other log on information (collectively, “Registration Information”), and agree to promptly notify us at support@vuefinance.com if you discover or suspect unauthorized user account access. If you permit others to use your Registration Information, you are responsible for activities of such users that occur in connection with your user account.']
      }, {
        title: 'Termination',
        content: ['Vue Finance, Inc. reserves the right to, and may, terminate or temporarily suspend your access to all or any part of the Service, without notice, for conduct that Vue Finance, Inc. believes violates these Terms or any of its policies, procedures, rules, regulations or guidelines, or for any other reason in its sole discretion.', 'All provisions of these Terms which by their nature should survive termination shall survive termination, including, ownership provisions, warranty disclaimers, indemnity and limitations of liability.']
      }, {
        title: 'Communications',
        content: ['By creating a user account on our Service, you agree to subscribe to newsletters, marketing or promotional materials and other information we may send. However, you may opt out of receiving any, or all, of these communications from us by following the unsubscribe link or instructions provided in any email we send.']
      }, {
        title: 'Subscriptions',
        content: ['Some parts of the Service are billed on a subscription basis ("Subscription(s)"). You will be billed in advance on a recurring and periodic basis ("Billing Cycle"). Billing cycles are set either on a monthly or annual basis, depending on the type of subscription plan you select when purchasing a Subscription.', 'At the end of each Billing Cycle, your Subscription will automatically renew under the exact same conditions unless you cancel it or Vue Finance, Inc. cancels it. You may cancel your Subscription renewal by contacting Vue Finance, Inc. customer support team at support@vuefinance.com.', 'A valid payment method, including credit card, is required to process the payment for your Subscription. You shall provide Vue Finance, Inc. with accurate and complete billing information including full name, address, state, zip code, telephone number, and a valid payment method information. By submitting such payment information, you automatically authorize Vue Finance, Inc. to charge all Subscription fees incurred through your user account to any such payment instruments.', 'Should automatic billing fail to occur for any reason, Vue Finance, Inc. will issue an electronic invoice indicating that you must proceed manually, within a certain deadline date, with the full payment corresponding to the billing period as indicated on the invoice.']
      }, {
        terms: 'Free Trial',
        content: ['Vue Finance, Inc. may, at its sole discretion, offer a Subscription with a free trial for a limited period of time ("Free Trial").', 'You may be required to enter your billing information in order to sign up for the Free Trial.', 'If you do enter your billing information when signing up for the Free Trial, you will not be charged by Vue Finance, Inc. until the Free Trial has expired. On the last day of the Free Trial period, unless you have cancelled your Subscription, you will be automatically charged the applicable Subscription fees for the type of Subscription you have selected. At any time and without notice, Vue Finance, Inc. reserves the right to (i) modify the terms and conditions of the Free Trial offer, or (ii) cancel such Free Trial offer.']
      }, {
        title: 'Fee Changes',
        content: ['Vue Finance, Inc., in its sole discretion and at any time, may modify the Subscription fees for the Subscriptions. Any Subscription fee change will become effective at the end of the then-current Billing Cycle.', 'Vue Finance, Inc. will provide you with a reasonable prior notice of any change in Subscription fees to give you an opportunity to terminate your Subscription before such change becomes effective.', 'Your continued use of the Service after the Subscription fee change comes into effect constitutes your agreement to pay the modified Subscription fee amount.']
      }, {
        title: 'Refunds',
        content: ['Certain refund requests for Subscriptions may be considered by Vue Finance, Inc. on a case-by-case basis and granted in sole discretion of Vue Finance, Inc..']
      }, {
        title: 'Links To Other Websites',
        content: ['Our Service may contain links to third party websites or services that are not owned or controlled by Vue Finance, Inc..', 'Vue Finance, Inc. has no control over, and assumes no responsibility for the content, privacy policies, or practices of any third party websites or services. We do not warrant the offerings of any of these entities/individuals or their websites.', 'You acknowledge and agree that Vue Finance, Inc. shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with use of or reliance on any such content, goods or services available on or through any such third party websites or services.', 'We strongly advise you to read the terms and conditions and privacy policies of any third party websites or services that you visit.']
      }, {
        title: 'Third Party Content',
        content: ['We may provide information about third party products, services, activities or events, or we may allow Third Party Service Providers to make their content and information available on or through the Services (collectively, “Third Party Content”). We provide Third Party Content as a service to those interested in such content. Your dealings or correspondence with third parties and your use of or interaction with any Third Party Content are solely between you and the third party.']
      }, {
        title: 'External Information from Third Party Sites',
        content: ['You may direct Vue Finance, Inc. to retrieve your own information maintained online by third-parties with which you have a customer relationship, maintain accounts or engage in financial transactions (“External Information”). Vue Finance, Inc. works with one or more online service providers to access this External Information. Vue Finance, Inc. does not review the External Information for accuracy, legality or non-infringement. Vue Finance, Inc. is not responsible for the External Information or products and services offered by or on third-party sites.', 'Vue Finance, Inc. cannot always foresee or anticipate technical or other difficulties which may result in failure to obtain data or loss of data, personalization settings or other service interruptions. Vue Finance, Inc. cannot assume responsibility for the timeliness, accuracy, deletion, non-delivery or failure to store the External Information.']
      }, {
        title: 'Disclaimer',
        content: ['YOUR USE OF THE SERVICE AND ALL INFORMATION, PRODUCTS AND OTHER CONTENT (INCLUDING EXTERNAL INFORMATION AND THIRD PARTY CONTENT) INCLUDED IN OR ACCESSIBLE IN CONNECTION WITH YOUR USE OF THE SERVICE (COLLECTIVELY, THE “DISCLAIMED SERVICES”) IS AT YOUR SOLE RISK. EXCEPT AS OTHERWISE PROVIDED IN WRITING BY US, THE DISCLAIMED SERVICES ARE PROVIDED ON AN “AS IS” AND “AS AVAILABLE” BASIS, WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE AND NON-INFRINGEMENT. FURTHERMORE, Vue Finance MAKES NO WARRANTY THAT (I) THE DISCLAIMED SERVICES WILL MEET YOUR REQUIREMENTS; (II) THE DISCLAIMED SERVICES WILL BE UNINTERRUPTED, TIMELY, SECURE, OR ERROR-FREE; OR (III) THE RESULTS THAT MAY BE OBTAINED FROM THE USE OF THE DISCLAIMED SERVICES WILL BE ACCURATE OR RELIABLE. YOU ASSUME THE ENTIRE RISK AS TO THE QUALITY AND PERFORMANCE OF THE DISCLAIMED SERVICES, AND ARE SOLELY RESPONSIBLE FOR ANY DAMAGE TO YOUR SYSTEMS OR DEVICES, OR LOSS OF DATA, RESULTING FROM YOUR USE OF THE DISCLAIMED SERVICES, INCLUDING DUE TO UNAUTHORIZED USERS (SUCH AS HACKERS), VIRUSES, WORMS, TROJAN HORSES, OR OTHER UNDESIRABLE DATA OR SOFTWARE.']
      }, {
        title: 'Indemnification',
        content: ['You agree to defend, indemnify and hold harmless Vue Finance, Inc. and its licensee and licensors, and their employees, contractors, agents, officers and directors, from and against any and all claims, damages, obligations, losses, liabilities, costs or debt, and expenses (including attorney\'s fees), resulting from or arising out of a) your use and access of the Service, by you or any person using your user account and password; b) a breach of these Terms, or c) Content posted on the Service.']
      }, {
        title: 'Limitation Of Liability',
        content: ['In no event shall Vue Finance, Inc., nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from (i) your access to or use of or inability to access or use the Service; (ii) any conduct or content of any third party on the Service; (iii) any content obtained from the Service; and (iv) unauthorized access, use or alteration of your transmissions or content, whether based on warranty, contract, tort (including negligence) or any other legal theory, whether or not we have been informed of the possibility of such damage, and even if a remedy set forth herein is found to have failed of its essential purpose.']
      }, {
        title: 'Exclusions',
        content: ['Some jurisdictions do not allow the exclusion of certain warranties or the exclusion or limitation of liability for consequential or incidental damages, so the limitations above may not apply to you.']
      }, {
        title: 'Governing Law',
        content: ['These Terms shall be governed and construed in accordance with the laws of Delaware, United States, without regard to its conflict of law provisions.', 'Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights. If any provision of these Terms is held to be invalid or unenforceable by a court, the remaining provisions of these Terms will remain in effect. These Terms constitute the entire agreement between us regarding our Service, and supersede and replace any prior agreements we might have had between us regarding the Service.']
      }, {
        title: 'Changes',
        content: ['We may make changes to these Terms from time to time. If we make changes, we will provide you with notice of such changes, such as by sending an email, providing a notice through the Service or updating the date at the top of these Terms. Unless we say otherwise in our notice, the amended terms will be effective immediately, and your continued use of our Service after we provide such notice will confirm your acceptance of the changes. If you do not agree to the amended terms, you must stop using the Service.']
      }, {
        title: 'Miscellaneous',
        content: ['The section titles in these Terms are for convenience only and have no legal or contractual effect. The word “including” means “including without limitation”.', 'If you have any questions about these Terms or the Service, please contact us at support@vuefinance.com.']
      }, {
        title: 'Contact Information',
        content: ['Vue Finance, Inc.', '260 1st Ave S', 'Suite 200', 'St. Petersburg, Florida 33701', 'Email: support@vuefinance.com']
      }]
    };
  }
});

/***/ }),

/***/ "0hVP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1Gnk":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;

/***/ }),

/***/ "1LFx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-bottom":"72px"}},[_c('Hero',{attrs:{"title":"Vue Finance - Closed Registration","description":"","minHeight":"500px","backgroundColor":"#2c3849"}}),_vm._v(" "),_c('DenseContent',{attrs:{"content":_vm.content}}),_vm._v(" "),_c('div',{staticStyle:{"padding-bottom":"38px","padding-left":"18vw","padding-right":"18vw"}},[_c('h2',[_vm._v("Sign up for our mailing list!")]),_vm._v(" "),_c('EmailListSignupForm')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1Tda":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys  = __webpack_require__("dy8G")
  , gOPS     = __webpack_require__("+Rk1")
  , pIE      = __webpack_require__("1Gnk")
  , toObject = __webpack_require__("FUac")
  , IObject  = __webpack_require__("4JPz")
  , $assign  = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("W3U9")(function(){
  var A = {}
    , B = {}
    , S = Symbol()
    , K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function(k){ B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
  var T     = toObject(target)
    , aLen  = arguments.length
    , index = 1
    , getSymbols = gOPS.f
    , isEnum     = pIE.f;
  while(aLen > index){
    var S      = IObject(arguments[index++])
      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
      , length = keys.length
      , j      = 0
      , key;
    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
  } return T;
} : $assign;

/***/ }),

/***/ "1itW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailSignupSection_vue__ = __webpack_require__("kAHB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0de23b50_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmailSignupSection_vue__ = __webpack_require__("8g6Q");
function injectStyle (ssrContext) {
  __webpack_require__("dmJG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0de23b50"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailSignupSection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0de23b50_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmailSignupSection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1uhW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DenseContent_vue__ = __webpack_require__("hph6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_814a4f4c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DenseContent_vue__ = __webpack_require__("aSSA");
function injectStyle (ssrContext) {
  __webpack_require__("ditZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-814a4f4c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DenseContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_814a4f4c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DenseContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2GEH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Row',[_c('Hero',{attrs:{"isMobile":_vm.isMobile,"title":_vm.content.title,"description":_vm.content.description,"backgroundColor":_vm.content.backgroundColor,"image":_vm.content.image,"textShadow":false}}),_vm._v(" "),_c('ContentImageSection',{attrs:{"title":_vm.content.problem.title,"windowWidth":_vm.windowWidth,"descriptions":_vm.content.problem.descriptions,"image":_vm.content.problem.image,"type":"img-right"}}),_vm._v(" "),_c('ContentImageSection',{attrs:{"title":_vm.content.solution.title,"windowWidth":_vm.windowWidth,"descriptions":_vm.content.solution.descriptions,"image":_vm.content.solution.image,"type":!_vm.isMobile? 'img-left' : 'img-right'}}),_vm._v(" "),(_vm.content.demo)?_c('DemonstrationSection',{attrs:{"windowWidth":_vm.windowWidth,"isMobile":_vm.isMobile,"title":_vm.content.demo.title,"sections":_vm.content.demo.sections}}):_vm._e(),_vm._v(" "),_c('SectionNavigation',{attrs:{"current":_vm.content.id}}),_vm._v(" "),_c('EmailSignupSection',{attrs:{"isMobile":_vm.isMobile}}),_vm._v(" "),_c('AggressiveCTA',{attrs:{"isMobile":_vm.isMobile}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3PJR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NetWorthIndicator_vue__ = __webpack_require__("U0U0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54af738c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NetWorthIndicator_vue__ = __webpack_require__("/Qhs");
function injectStyle (ssrContext) {
  __webpack_require__("0hVP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NetWorthIndicator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54af738c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NetWorthIndicator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "45GK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4JPz":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("emx8");
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),

/***/ "4Ruh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangeIndicatorTable_vue__ = __webpack_require__("wNNh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d7c184e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangeIndicatorTable_vue__ = __webpack_require__("UeQB");
function injectStyle (ssrContext) {
  __webpack_require__("9pWT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangeIndicatorTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d7c184e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangeIndicatorTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4ez0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4pYr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueFooter_vue__ = __webpack_require__("TMEZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88ab5dc6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VueFooter_vue__ = __webpack_require__("fX05");
function injectStyle (ssrContext) {
  __webpack_require__("sbQ8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-88ab5dc6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88ab5dc6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VueFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5goi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Row',{attrs:{"type":"flex","align":"middle"}},[_c('Col',[_c('Input',{staticStyle:{"width":"280px","margin-right":"8px"},attrs:{"size":_vm.size,"type":"email","placeholder":"Enter your email","icon":"email","enter-button":"true","clearable":"","element-id":"email-list-signup-input"},on:{"on-enter":_vm.submitEmail},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1),_vm._v(" "),_c('Col',{staticStyle:{"margin-bottom":"0px"},attrs:{"span":"4"}},[_c('Button',{attrs:{"type":"default"},on:{"click":_vm.submitEmail}},[_vm._v("Join Email List")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "69rs":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};

/***/ }),

/***/ "6MC7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SectionNavigation_vue__ = __webpack_require__("GT5+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b57960ac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SectionNavigation_vue__ = __webpack_require__("cT2H");
function injectStyle (ssrContext) {
  __webpack_require__("RMiN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b57960ac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SectionNavigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b57960ac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SectionNavigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6Qai":
/***/ (function(module, exports) {

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};

/***/ }),

/***/ "7Adc":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),

/***/ "7cxW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    type: { type: String, default: 'primary' },
    arrow: { type: Boolean, default: false },
    title: { type: String, default: 'Get Started' },
    tall: { type: Boolean, default: false }
  },
  data: function data() {
    return { loginUrl: "https://app.vuefinance.com/login" };
  }
});

/***/ }),

/***/ "8g6Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Row',{staticClass:"email-signup-section border-top",attrs:{"type":"flex","justify":"space-around","align":"middle"}},[_c('Col',{staticClass:"item"},[_c('h2',{staticClass:"title"},[_vm._v("Keep in Touch!")]),_vm._v(" "),_c('p',{staticClass:"subtitle"},[_vm._v("Join our email list to receive product updates, company news, and tips on how to manage and analyze your portfolio.")])]),_vm._v(" "),_c('Col',[_c('EmailListSignupForm',{attrs:{"size":"large"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8o1j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_iview__ = __webpack_require__("BTaQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_iview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_iview__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    size: { type: String, default: 'default' }
  },
  data: function data() {
    return {
      email: null
    };
  },

  methods: {
    formValid: function formValid() {
      var vm = this;

      if (!vm.email || vm.email === '') {
        return false;
      }

      return true;
    },
    submitEmail: function submitEmail() {
      var vm = this;

      if (!vm.formValid()) {
        __WEBPACK_IMPORTED_MODULE_1_iview__["Notice"].error({
          title: 'Invalid Email',
          content: 'Please enter a valid email'
        });

        return false;
      }

      var portalId = '5143395';
      var formGuid = '333b37b6-ef50-4748-bc15-882273f6ff07';
      var destinationUrl = 'https://api.hsforms.com/submissions/v3/integration/submit/' + portalId + '/' + formGuid;
      var now = Date.now();
      var data = {
        submittedAt: now,
        fields: [{ name: 'email', value: vm.email }],
        context: {
          hutk: window.__hsUserToken, // Must have Hubspot cookie loaded
          // ipAddress: ,
          pageName: vm.$route.fullPath,
          pageUri: window.location.href
          // skipValidation: ,
          // },
          // legalConsentOptions: {
          //   consent: ,
        }
      };

      return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(destinationUrl, data).then(function () {
        vm.email = null;
        __WEBPACK_IMPORTED_MODULE_1_iview__["Notice"].success({ title: 'Thanks for joining our email list!' });
      }).catch(function (err) {
        var responseData = err && err.response && err.response.data;
        var hubspotErrorResponse = responseData && responseData.errors && responseData.errors.length ? responseData.errors[0] : false;

        var title = 'Failed to join email list';
        var description = 'There was a problem adding you to our email list. Please try again later.';
        var duration = 0;

        if (hubspotErrorResponse.errorType === 'INVALID_EMAIL') {
          title = 'Please provide a valid email';
          description = undefined;
          duration = 4.5;
        }

        __WEBPACK_IMPORTED_MODULE_1_iview__["Notice"].error({
          title: title,
          desc: description,
          duration: duration
        });
      }).finally(function () {
        vm.loading = false;
      });
    }
  }
});

/***/ }),

/***/ "92J2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AggressiveCTA_vue__ = __webpack_require__("SKzV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53c19842_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AggressiveCTA_vue__ = __webpack_require__("xslW");
function injectStyle (ssrContext) {
  __webpack_require__("ShJL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-53c19842"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AggressiveCTA_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53c19842_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AggressiveCTA_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9oeD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNavCard_vue__ = __webpack_require__("DHTR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e3af751_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageNavCard_vue__ = __webpack_require__("SRpw");
function injectStyle (ssrContext) {
  __webpack_require__("Zqmj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2e3af751"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNavCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e3af751_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageNavCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9pWT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A1R5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlatformComponentsList_vue__ = __webpack_require__("dlME");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0c9b9b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlatformComponentsList_vue__ = __webpack_require__("QeSx");
function injectStyle (ssrContext) {
  __webpack_require__("BeaH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d0c9b9b6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlatformComponentsList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0c9b9b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlatformComponentsList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AEfT":
/***/ (function(module, exports) {

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),

/***/ "Abtc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BeaH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BrGd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Hero__ = __webpack_require__("UfZ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NestedIcon__ = __webpack_require__("rNVv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GetStartedButton__ = __webpack_require__("Lehf");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { NestedIcon: __WEBPACK_IMPORTED_MODULE_1__NestedIcon__["a" /* default */], Hero: __WEBPACK_IMPORTED_MODULE_0__Hero__["a" /* default */], GetStartedButton: __WEBPACK_IMPORTED_MODULE_2__GetStartedButton__["a" /* default */] }
});

/***/ }),

/***/ "Bxrf":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("AEfT");
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};

/***/ }),

/***/ "D3Ap":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Hero__ = __webpack_require__("UfZ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PlatformComponentsList__ = __webpack_require__("A1R5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_platformComponents__ = __webpack_require__("Z1NO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ScheduleDemo__ = __webpack_require__("SQIg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SecuritySection__ = __webpack_require__("xeRV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AggressiveCTA__ = __webpack_require__("92J2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EmailSignupSection__ = __webpack_require__("1itW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AssetTypesSection__ = __webpack_require__("lPXq");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Hero: __WEBPACK_IMPORTED_MODULE_0__Hero__["a" /* default */], PlatformComponentsList: __WEBPACK_IMPORTED_MODULE_1__PlatformComponentsList__["a" /* default */], ScheduleDemo: __WEBPACK_IMPORTED_MODULE_3__ScheduleDemo__["a" /* default */], SecuritySection: __WEBPACK_IMPORTED_MODULE_4__SecuritySection__["a" /* default */], AggressiveCTA: __WEBPACK_IMPORTED_MODULE_5__AggressiveCTA__["a" /* default */], EmailSignupSection: __WEBPACK_IMPORTED_MODULE_6__EmailSignupSection__["a" /* default */], AssetTypesSection: __WEBPACK_IMPORTED_MODULE_7__AssetTypesSection__["a" /* default */] },
  props: ['windowWidth', 'isMobile'],
  data: function data() {
    return {
      platformComponents: __WEBPACK_IMPORTED_MODULE_2__services_platformComponents__["a" /* default */],
      title: 'Powerful Insights on your Personal Finances & Investments',
      description: 'Vue Finance gives you a complete and accurate picture of your finances. Track your net worth, build custom reports, and make confident, data-driven financial decisions.',
      backgroundColor: 'linear-gradient(rgb(25, 45, 74), rgb(22, 40, 66))'
    };
  },

  computed: {
    backgroundImage: function backgroundImage() {
      return !this.isMobile ? "linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.5), rgba(0,0,0,0.4), rgba(0,0,0,0.1)), url('/static/reviewing-finances-in-coffee-shop.JPG')" : 'rgb(38, 49, 65)';
    }
  }
});

/***/ }),

/***/ "DHTR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: { type: String, required: true },
    route: { type: String, required: true },
    title: { type: String, required: true },
    content: { type: String, required: true },
    direction: { type: String, required: true }
  },
  data: function data() {
    var vm = this;
    return {
      sectionStyle: { background: vm.color },
      contentStyle: vm.direction === 'next' ? { 'text-align': 'right' } : { 'text-align': 'left' }
    };
  }
});

/***/ }),

/***/ "DpAH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("p/Cb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GetStartedButton__ = __webpack_require__("Lehf");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var polyStyles = {
  content: '',
  display: 'block',
  width: '100%',
  // background: '#f8f8f9',
  background: '#fcfcfc',
  position: 'absolute',
  left: '0',
  bottom: '-1px',
  '-webkit-clip-path': 'polygon(100% 0,100% 0,100% 100%,0 100%)',
  'clip-path': 'polygon(100% 0,100% 0,100% 100%,0 100%)',
  'z-index': '1',
  height: '150px'
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: { GetStartedButton: __WEBPACK_IMPORTED_MODULE_1__GetStartedButton__["a" /* default */] },
  props: {
    isMobile: { type: Boolean },
    title: { type: String, required: true },
    description: { type: String },
    backgroundColor: { type: String },
    contentWidth: { type: String, default: '514px' },
    image: { type: String },
    backgroundImage: { type: String },
    minHeight: { type: String, default: '550px' },
    slant: { type: Boolean, default: true },
    scrollOffset: { type: Number, default: -90 },
    titleStyles: { type: Object },
    textShadow: { type: Boolean, default: true }
  },
  data: function data() {
    return {
      // background: #263141;
      poly: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(polyStyles)
    };
  },

  computed: {
    maxImageWidth: function maxImageWidth() {
      if (!this.image) {
        return '400px';
      } // to give title more room on pages with no image
      return !this.isMobile ? '600px' : '80vw';
    },
    titleStyle: function titleStyle() {
      var vm = this;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ 'font-size': '2rem' }, vm.titleStyles || {});
    }
  }
});

/***/ }),

/***/ "E7mI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__charts_PortfolioDist__ = __webpack_require__("XKK6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CardHeader__ = __webpack_require__("M9NS");
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['isMobile'],
  components: { PortfolioDist: __WEBPACK_IMPORTED_MODULE_0__charts_PortfolioDist__["a" /* default */], CardHeader: __WEBPACK_IMPORTED_MODULE_1__CardHeader__["a" /* default */] }
});

/***/ }),

/***/ "EYYO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_faqs__ = __webpack_require__("/c8C");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return { faqs: __WEBPACK_IMPORTED_MODULE_0__services_faqs__["a" /* default */] };
  },

  props: {
    showAnnual: Boolean,
    buttonType: String,
    plan: {
      title: String,
      description: String,
      annualPrice: String,
      monthlyPrice: String,
      featureList: Array
    }
  },
  methods: {
    buildUrl: function buildUrl(plan) {
      var vm = this;
      return "https://app.vuefinance.com/getting-started/subscription" + '?tier=' + plan.tier + '&interval=' + (vm.showAnnual ? 'year' : 'month');
    }
  }
});

/***/ }),

/***/ "FUac":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("Zlf3");
module.exports = function(it){
  return Object(defined(it));
};

/***/ }),

/***/ "FZMV":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("7Adc")
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),

/***/ "G8Cq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Row',{staticStyle:{"padding":"3vw 2vw 6vw 2vw","background":"#fcfcfc"}},[_c('h2',{staticStyle:{"font-size":"28px","text-align":"center","padding":"2vw 10vw 10vw"}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._l((_vm.sections),function(section,$index){return _c('Row',{key:$index},[_c('ContentImageSection',{attrs:{"windowWidth":_vm.windowWidth,"isMobile":_vm.isMobile,"title":section.title,"descriptions":section.descriptions,"image":section.image,"component":section.component,"type":!_vm.isMobile? _vm.isEven($index) ? 'img-right' : 'img-left' : 'img-right',"cta":true}})],1)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GDP0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClosedRegistration_vue__ = __webpack_require__("xjCK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b7fa259_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClosedRegistration_vue__ = __webpack_require__("1LFx");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClosedRegistration_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b7fa259_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClosedRegistration_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GT5+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_pages__ = __webpack_require__("f6Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PageNavCard__ = __webpack_require__("9oeD");
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { PageNavCard: __WEBPACK_IMPORTED_MODULE_1__PageNavCard__["a" /* default */] },
  props: { current: { type: String, required: true } },
  data: function data() {
    var vm = this;
    var currentPage = __WEBPACK_IMPORTED_MODULE_0__services_pages__["a" /* default */][vm.current];
    var nextPage = __WEBPACK_IMPORTED_MODULE_0__services_pages__["a" /* default */][currentPage.sectionNavigation.next.id];
    var prevPage = __WEBPACK_IMPORTED_MODULE_0__services_pages__["a" /* default */][currentPage.sectionNavigation.prev.id];
    var next = {
      title: '' + currentPage.sectionNavigation.next.title,
      color: nextPage.color,
      content: currentPage.sectionNavigation.next.content,
      route: nextPage.route
    };
    var prev = {
      title: '' + currentPage.sectionNavigation.prev.title,
      color: prevPage.color,
      content: currentPage.sectionNavigation.prev.content,
      route: prevPage.route
    };

    return { next: next, prev: prev, windowWidth: window.innerWidth };
  }
});

/***/ }),

/***/ "GebP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Row',{class:{
      'padding-50': !_vm.isMobile,
      'padding-16': _vm.isMobile,
      'header-tall': !_vm.isMobile,
      'header-short': _vm.isMobile,
      'dark-background': _vm.isMobile,
      'animate-header': _vm.atTopOfPage,
      },attrs:{"type":"flex","id":"header","align":"middle"}},[(!_vm.isMobile)?_c('Col',{attrs:{"span":"6"}},[_c('Row',{attrs:{"type":"flex","align":"middle","justify":"start"}},[_c('router-link',{attrs:{"to":{ name: 'Home' }}},[_c('Row',{attrs:{"type":"flex","align":"middle","justify":"start"}},[_c('img',{attrs:{"src":"/static/logo-89x90.png","width":"30px"}}),_vm._v(" "),_c('h1',{staticClass:"logo-text",class:{ 'color-black': _vm.atTopOfPage }},[_vm._v("Vue Finance")])])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('Col',{attrs:{"span":"13"}},[_c('Row',{attrs:{"type":"flex","align":"middle","justify":"start"}},[_c('router-link',{attrs:{"to":{ name: 'Home' }}},[_c('Row',{attrs:{"type":"flex","align":"middle","justify":"start"}},[_c('img',{attrs:{"src":"/static/logo-89x90.png","width":"30px"}}),_vm._v(" "),_c('h2',{staticClass:"logo-text",class:{ 'color-black': _vm.atTopOfPage }},[_vm._v("Vue Finance")])])],1)],1)],1):_vm._e(),_vm._v(" "),(!_vm.isMobile)?_c('Col',{attrs:{"span":"2"}},[_c('Row',{attrs:{"type":"flex","align":"middle","justify":"center"}})],1):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('Col',{attrs:{"span":"7"}}):_vm._e(),_vm._v(" "),(!_vm.isMobile)?_c('Col',{attrs:{"span":"16"}},[_c('Row',{attrs:{"type":"flex","align":"middle","justify":"end"}},[_c('Dropdown',{staticClass:"nav-item",attrs:{"placement":"bottom-end","trigger":"click"},on:{"on-visible-change":_vm.onDropdownChange,"on-click":_vm.navigate}},[_c('a',{staticClass:"nav-item",class:{ 'color-black': _vm.atTopOfPage }},[_c('h3',[_vm._v("\n              How it Works \n              "),_c('Icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.productDropdownIsOpen),expression:"!productDropdownIsOpen"}],attrs:{"type":"ios-arrow-down"}}),_vm._v(" "),_c('Icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.productDropdownIsOpen),expression:"productDropdownIsOpen"}],attrs:{"type":"ios-arrow-up"}})],1)]),_vm._v(" "),_c('DropdownMenu',{staticStyle:{"text-align":"center"},attrs:{"slot":"list"},slot:"list"},_vm._l((_vm.componentList),function(item){return _c('DropdownItem',{key:item.id,attrs:{"name":item.card.title}},[_c('Row',{attrs:{"type":"flex","justify":"start","align":"middle"}},[_c('router-link',{staticStyle:{"color":"unset"},attrs:{"to":{ name: item.route }}},[_c('Icon',{staticStyle:{"padding-right":"4px"},attrs:{"type":item.icon,"color":item.color}}),_vm._v("\n                  "+_vm._s(item.card.title)+"\n                ")],1)],1)],1)}))],1),_vm._v(" "),_c('router-link',{staticClass:"nav-item",class:{ 'color-black': _vm.atTopOfPage },attrs:{"to":{ name: 'Features' }}},[_c('h3',[_vm._v("Features")])]),_vm._v(" "),_c('router-link',{staticClass:"nav-item",class:{ 'color-black': _vm.atTopOfPage },attrs:{"to":{ name: 'Pricing' }}},[_c('h3',[_vm._v("Pricing")])]),_vm._v(" "),_c('GetStartedButton')],1)],1):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('Col',{attrs:{"span":"4"}},[_c('Row',[_c('Dropdown',{attrs:{"trigger":"click","placement":"bottom-end"},on:{"on-click":_vm.navigate}},[_c('Button',{attrs:{"icon":"navicon","shape":"circle"}}),_vm._v(" "),_c('DropdownMenu',{attrs:{"slot":"list"},slot:"list"},[_c('DropdownItem',[_c('router-link',{staticStyle:{"color":"unset"},attrs:{"to":{ name: 'Home' }}},[_c('h4',[_vm._v("Home")])])],1),_vm._v(" "),_c('DropdownItem',{attrs:{"disabled":""}},[_c('h4',[_vm._v("How it Works")])]),_vm._v(" "),_vm._l((_vm.componentList),function(item){return _c('DropdownItem',{key:item.id,staticStyle:{"margin-left":"8px"},attrs:{"name":item.card.title}},[_c('Row',{attrs:{"type":"flex","justify":"start","align":"middle"}},[_c('router-link',{staticStyle:{"color":"unset"},attrs:{"to":{ name: item.route }}},[_c('Icon',{staticStyle:{"padding-right":"4px"},attrs:{"type":item.icon,"color":item.color}}),_vm._v("\n                  "+_vm._s(item.card.title)+"\n                ")],1)],1)],1)}),_vm._v(" "),_c('DropdownItem',[_c('router-link',{staticStyle:{"color":"unset"},attrs:{"to":{ name: 'Features' }}},[_c('h4',[_vm._v("Features")])])],1),_vm._v(" "),_c('DropdownItem',[_c('router-link',{staticStyle:{"color":"unset"},attrs:{"to":{ name: 'Pricing' }}},[_c('h4',[_vm._v("Pricing")])])],1),_vm._v(" "),_c('DropdownItem',{attrs:{"divided":"","name":"Get Early Access"}},[_c('Row',{attrs:{"type":"flex","justify":"center"}},[_c('GetStartedButton',{attrs:{"type":"primary"}})],1)],1)],2)],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Hftg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Col',[_c('Hero',{attrs:{"title":"Vue Finance - Features","minHeight":"500px","backgroundColor":"#2c3849","description":"Providing you with all the tools you need to stay on top of your portfolio and make financial decisions confidently."}}),_vm._v(" "),_c('Row',{staticClass:"container",attrs:{"type":"flex","justify":"space-around"}},[_c('Col',{staticStyle:{"max-width":"600px"}},[_c('div',{staticClass:"feature-item"},[_c('h1',{attrs:{"id":"account-aggregation"}},[_c('Icon',{attrs:{"type":"ios-ionic-outline"}}),_vm._v(" Account Aggregation")],1),_vm._v(" "),_c('h3',[_vm._v("We integrate with over 14,000 financial institutions to connect Checking, Savings, Brokerage, and Retirement accounts, and more. Once connected we stay in sync with the balance and position of any external account.")]),_vm._v(" "),_c('GetStartedButton',{staticClass:"vertical-margin-8"})],1),_vm._v(" "),_c('div',{staticClass:"feature-item"},[_c('h1',{attrs:{"id":"custom-assessments"}},[_c('Icon',{attrs:{"type":"ios-pie-outline"}}),_vm._v(" Custom Assessments")],1),_vm._v(" "),_c('h3',[_vm._v("We give you the ablility to build your own dashboard using our Assessment Builder. You can create various types of dynamic charts, reports, and other visualizations to get the information and insights you care about the most.")]),_vm._v(" "),_c('GetStartedButton',{staticClass:"vertical-margin-8"})],1),_vm._v(" "),_c('div',{staticClass:"feature-item"},[_c('Row',{attrs:{"type":"flex"}},[_c('NestedIcon'),_vm._v(" "),_c('h1',{attrs:{"id":"nested-accounts"}},[_vm._v("Nested Accounts")])],1),_vm._v(" "),_c('h3',[_vm._v("We allow nested accounts in order to properly represent any assets you own through a separate entity. This is useful if you own real estate through an LLC/Trust or have a business with assets that are not personally owned.")]),_vm._v(" "),_c('GetStartedButton',{staticClass:"vertical-margin-8"})],1),_vm._v(" "),_c('div',{staticClass:"feature-item"},[_c('h1',{attrs:{"id":"configurable-valuations"}},[_c('Icon',{attrs:{"type":"ios-gear-outline"}}),_vm._v(" Configurable Valuations (Formulas)")],1),_vm._v(" "),_c('h3',[_vm._v("We're the only personal finance software that lets "),_c('strong',[_vm._v("you")]),_vm._v(" decide how to value an asset. Use Formulas to define how to generate valuations for an account. You can even reference the value of another account in your formulas.")]),_vm._v(" "),_c('GetStartedButton',{staticClass:"vertical-margin-8"})],1),_vm._v(" "),_c('div',{staticClass:"feature-item"},[_c('h1',{attrs:{"id":"integrations"}},[_c('Icon',{attrs:{"type":"ios-color-filter-outline"}}),_vm._v(" Integrations")],1),_vm._v(" "),_c('h3',[_vm._v("In some cases, you'll want to pull a valuation of an asset from an external source. This is useful if you want to value real estate using Zillow, or a business using your accounting system. There is no need to duplicate any efforts to keep everything in sync.")]),_vm._v(" "),_c('GetStartedButton',{staticClass:"vertical-margin-8"})],1)]),_vm._v(" "),_c('Col',[_c('Affix',{attrs:{"offset-top":84}},[_c('Card',{staticStyle:{"width":"max-content"}},[_c('Row',{attrs:{"type":"flex","justify":"start"}},[_c('Col',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:({el: '#account-aggregation', offset: -84}),expression:"{el: '#account-aggregation', offset: -84}"}],attrs:{"href":"#"}},[_c('p',[_c('Icon',{attrs:{"type":"arrow-right-b"}}),_vm._v(" Account Aggregation")],1)]),_vm._v(" "),_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:({el: '#custom-assessments', offset: -84}),expression:"{el: '#custom-assessments', offset: -84}"}],attrs:{"href":"#"}},[_c('p',[_c('Icon',{attrs:{"type":"arrow-right-b"}}),_vm._v(" Custom Assessments")],1)]),_vm._v(" "),_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:({el: '#nested-accounts', offset: -84}),expression:"{el: '#nested-accounts', offset: -84}"}],attrs:{"href":"#"}},[_c('p',[_c('Icon',{attrs:{"type":"arrow-right-b"}}),_vm._v(" Nested Accounts")],1)]),_vm._v(" "),_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:({el: '#configurable-valuations', offset: -84}),expression:"{el: '#configurable-valuations', offset: -84}"}],attrs:{"href":"#"}},[_c('p',[_c('Icon',{attrs:{"type":"arrow-right-b"}}),_vm._v(" Configurable Valuations")],1)]),_vm._v(" "),_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:({el: '#integrations', offset: -84}),expression:"{el: '#integrations', offset: -84}"}],attrs:{"href":"#"}},[_c('p',[_c('Icon',{attrs:{"type":"arrow-right-b"}}),_vm._v(" Integrations")],1)])])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Hih6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailListSignupForm_vue__ = __webpack_require__("8o1j");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a80a86b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmailListSignupForm_vue__ = __webpack_require__("5goi");
function injectStyle (ssrContext) {
  __webpack_require__("J9o8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6a80a86b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailListSignupForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a80a86b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmailListSignupForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "J9o8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JNVo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Col',{staticStyle:{"background":"rgb(44, 56, 73)","color":"#fff","padding":"15vh 5vw"},attrs:{"id":"security"}},[_c('Row',{staticStyle:{"text-align":"center"},attrs:{"type":"flex","justify":"space-around","align":"middle"}},[_c('h1',{staticClass:"title"},[_vm._v("Security and Privacy, Prioritized.")])]),_vm._v(" "),_c('Row',{staticStyle:{"text-align":"center"},attrs:{"type":"flex","justify":"space-around","align":"middle"}},[_c('p',[_vm._v("Developed by financial technology experts using the industry's best security practices.")])]),_vm._v(" "),_c('Row',{staticStyle:{"background":"rgb(44, 56, 73)","color":"#fff","padding":"10vh 5vw"},attrs:{"type":"flex","justify":"space-around"}},[_c('Col',{staticStyle:{"width":"300px"}},[_c('p',[_vm._v("Our team has developed highly-available and secure software for nation-wide financial institutions to manage billions of US Dollars.")])]),_vm._v(" "),_c('Col',{staticStyle:{"margin":"42px"}},[_c('Icon',{attrs:{"type":"android-lock","size":"52"}})],1),_vm._v(" "),_c('Col',{staticStyle:{"width":"300px"}},[_c('p',[_c('Icon',{staticClass:"green",attrs:{"type":"ios-checkmark-outline"}}),_vm._v(" "),_c('strong',[_vm._v("256-Bit")]),_vm._v(" encryption at rest")],1),_vm._v(" "),_c('p',[_c('Icon',{staticClass:"green",attrs:{"type":"ios-checkmark-outline"}}),_vm._v(" "),_c('strong',[_vm._v("256-Bit")]),_vm._v(" encrypted traffic")],1),_vm._v(" "),_c('p',[_c('Icon',{staticClass:"green",attrs:{"type":"ios-checkmark-outline"}}),_vm._v(" Company policies "),_c('strong',[_vm._v("prioritizing security")])],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Jemx":
/***/ (function(module, exports, __webpack_require__) {

var anObject       = __webpack_require__("Xc+a")
  , IE8_DOM_DEFINE = __webpack_require__("aLLD")
  , toPrimitive    = __webpack_require__("db+C")
  , dP             = Object.defineProperty;

exports.f = __webpack_require__("iPQn") ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};

/***/ }),

/***/ "JyHQ":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("onsV");
module.exports = __webpack_require__("hC6b").Object.assign;

/***/ }),

/***/ "Kn4X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "L8Mf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Hero',{attrs:{"title":"Vue Finance - Privacy Policy","description":"","minHeight":"500px","backgroundColor":"#2c3849"}}),_vm._v(" "),_c('DenseContent',{attrs:{"content":_vm.terms}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LDBk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LV4Q":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

/***/ }),

/***/ "Lehf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GetStartedButton_vue__ = __webpack_require__("7cxW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56897cd6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GetStartedButton_vue__ = __webpack_require__("qHOI");
function injectStyle (ssrContext) {
  __webpack_require__("s23M")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-56897cd6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GetStartedButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56897cd6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GetStartedButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LhBQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PortfolioDistCard_vue__ = __webpack_require__("E7mI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bbd282ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PortfolioDistCard_vue__ = __webpack_require__("NPn+");
function injectStyle (ssrContext) {
  __webpack_require__("LDBk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PortfolioDistCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bbd282ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PortfolioDistCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LmGY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DemonstrationSection_vue__ = __webpack_require__("oAcl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f5abcf0a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DemonstrationSection_vue__ = __webpack_require__("G8Cq");
function injectStyle (ssrContext) {
  __webpack_require__("tnE8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f5abcf0a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DemonstrationSection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f5abcf0a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DemonstrationSection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19ca5fe4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("lFLZ");
function injectStyle (ssrContext) {
  __webpack_require__("MfpC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19ca5fe4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M9NS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardHeader_vue__ = __webpack_require__("w3Xq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6535412c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardHeader_vue__ = __webpack_require__("swmp");
function injectStyle (ssrContext) {
  __webpack_require__("rxWb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6535412c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6535412c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MfpC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NE1x":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("RIdP");
module.exports = parseFloat;

/***/ }),

/***/ "NEk/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GetStartedButton__ = __webpack_require__("Lehf");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { GetStartedButton: __WEBPACK_IMPORTED_MODULE_0__GetStartedButton__["a" /* default */] },
  props: {
    isMobile: { type: Boolean },
    windowWidth: { type: Number, required: true },
    title: { type: String, required: true },
    descriptions: { type: Array, required: true },
    image: { type: String },
    component: { type: String },
    imageWidth: { type: String, default: '450px' },
    type: { type: String, enum: ['img-right', 'img-left'], default: 'img-right' },
    cta: { type: Boolean, default: false }
  }
});

/***/ }),

/***/ "NGZt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValuationsPage_vue__ = __webpack_require__("xYQJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45cb3bc2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValuationsPage_vue__ = __webpack_require__("2GEH");
function injectStyle (ssrContext) {
  __webpack_require__("O8j2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValuationsPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45cb3bc2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValuationsPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_iview__ = __webpack_require__("BTaQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_iview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_iview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_iview_dist_locale_en_US__ = __webpack_require__("hyJX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_iview_dist_locale_en_US___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_iview_dist_locale_en_US__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_scrollto__ = __webpack_require__("bm7V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_scrollto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_raven_js__ = __webpack_require__("/Hyb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_raven_js_plugins_vue__ = __webpack_require__("6fN7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_raven_js_plugins_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_raven_js_plugins_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_NetWorthCard__ = __webpack_require__("W2hP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_REvMarketCard__ = __webpack_require__("rwnw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_PortfolioDistCard__ = __webpack_require__("LhBQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_NetWorthIndicator__ = __webpack_require__("3PJR");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.














__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_scrollto___default.a);

// configure language
Object(__WEBPACK_IMPORTED_MODULE_1_iview__["locale"])(__WEBPACK_IMPORTED_MODULE_2_iview_dist_locale_en_US___default.a);

// import iview components
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Row', __WEBPACK_IMPORTED_MODULE_1_iview__["Row"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Col', __WEBPACK_IMPORTED_MODULE_1_iview__["Col"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Message', __WEBPACK_IMPORTED_MODULE_1_iview__["Message"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Modal', __WEBPACK_IMPORTED_MODULE_1_iview__["Modal"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Notice', __WEBPACK_IMPORTED_MODULE_1_iview__["Notice"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('From', __WEBPACK_IMPORTED_MODULE_1_iview__["From"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('FormItem', __WEBPACK_IMPORTED_MODULE_1_iview__["FormItem"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Form', __WEBPACK_IMPORTED_MODULE_1_iview__["Form"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Input', __WEBPACK_IMPORTED_MODULE_1_iview__["Input"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Card', __WEBPACK_IMPORTED_MODULE_1_iview__["Card"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Button', __WEBPACK_IMPORTED_MODULE_1_iview__["Button"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Icon', __WEBPACK_IMPORTED_MODULE_1_iview__["Icon"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Affix', __WEBPACK_IMPORTED_MODULE_1_iview__["Affix"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Poptip', __WEBPACK_IMPORTED_MODULE_1_iview__["Poptip"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('i-switch', __WEBPACK_IMPORTED_MODULE_1_iview__["Switch"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Dropdown', __WEBPACK_IMPORTED_MODULE_1_iview__["Dropdown"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('DropdownMenu', __WEBPACK_IMPORTED_MODULE_1_iview__["DropdownMenu"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('DropdownItem', __WEBPACK_IMPORTED_MODULE_1_iview__["DropdownItem"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Table', __WEBPACK_IMPORTED_MODULE_1_iview__["Table"]);
// Charts
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('NetWorthCard', __WEBPACK_IMPORTED_MODULE_8__components_NetWorthCard__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('REvMarketCard', __WEBPACK_IMPORTED_MODULE_9__components_REvMarketCard__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('PortfolioDistCard', __WEBPACK_IMPORTED_MODULE_10__components_PortfolioDistCard__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('NetWorthIndicator', __WEBPACK_IMPORTED_MODULE_11__components_NetWorthIndicator__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.config('https://b2cf8e0ac19a4aaab3204d294ca5b339@sentry.io/1199947', {
  environment: "production"
}).addPlugin(__WEBPACK_IMPORTED_MODULE_5_raven_js_plugins_vue___default.a, __WEBPACK_IMPORTED_MODULE_0_vue__["default"]).install();

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_6__App__["a" /* default */] }
});

/***/ }),

/***/ "NPn+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{style:({ width: _vm.isMobile ? '300px' : '434px' })},[_c('CardHeader',{attrs:{"slot":"title","title":"Portfolio Distribution"},slot:"title"}),_vm._v(" "),_c('Row',{staticClass:"feature-card",attrs:{"type":"flex","justify":"center","align":"middle"}},[_c('PortfolioDist',{staticStyle:{"height":"100%","width":"100%"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "O8j2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OPj5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PyvK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScheduleButton_vue__ = __webpack_require__("thJ3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdbad02a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScheduleButton_vue__ = __webpack_require__("+KaG");
function injectStyle (ssrContext) {
  __webpack_require__("Abtc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bdbad02a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScheduleButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdbad02a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScheduleButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Q0UO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QTEU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueHeader_vue__ = __webpack_require__("Ro/S");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23c32d7e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VueHeader_vue__ = __webpack_require__("GebP");
function injectStyle (ssrContext) {
  __webpack_require__("jCPM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-23c32d7e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23c32d7e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VueHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QeSx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Row',[_c('Col',{attrs:{"span":"24"}},[_c('Row',{staticClass:"plat-title",attrs:{"type":"flex","justify":"center"}},[_c('h1',{staticStyle:{"font-size":"28px","text-align":"center"}},[_vm._v("Cutting-Edge Tools For Managing Your Finances")])]),_vm._v(" "),_c('Row',{attrs:{"type":"flex","justify":"center"}},[_c('h3',{staticStyle:{"font-size":"1rem","max-width":"600px","text-align":"center","padding":"16px","padding-top":"0"}},[_vm._v("\n          Use our powerful suite of software to "),_c('strong',[_vm._v("visualize your entire portfolio")]),_vm._v(" in one place, and "),_c('strong',[_vm._v("track key performance metrics")]),_vm._v(" effortlessly.\n        ")])]),_vm._v(" "),_c('Row',{staticClass:"plat-card-list",attrs:{"type":"flex","justify":"center"}},_vm._l((_vm.list),function(item){return _c('Col',{key:item.title,staticClass:"plat-card-container"},[_c('router-link',{attrs:{"to":{ name: item.route }}},[_c('Card',{staticClass:"plat-card lift-on-hover"},[_c('Row',{staticStyle:{"padding-top":"8px","padding-bottom":"16px"},attrs:{"type":"flex","justify":"center"}},[_c('Icon',{attrs:{"type":item.icon,"color":item.color,"size":40}})],1),_vm._v(" "),_c('Row',{attrs:{"type":"flex","justify":"center","align":"middle"}},[_c('h2',[_vm._v(_vm._s(item.card.title))])]),_vm._v(" "),_c('Row',{staticClass:"plat-card-description",attrs:{"type":"flex","justify":"start"}},[_vm._v(_vm._s(item.card.description))]),_vm._v(" "),_c('Row',{attrs:{"type":"flex","justify":"center","align":"middle"}},[_c('Button',{attrs:{"type":"primary","long":""}},[_vm._v("Learn More "),_c('Icon',{attrs:{"type":"arrow-right-c"}})],1)],1)],1)],1)],1)}))],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QoAr":
/***/ (function(module, exports, __webpack_require__) {

var dP         = __webpack_require__("Jemx")
  , createDesc = __webpack_require__("6Qai");
module.exports = __webpack_require__("iPQn") ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};

/***/ }),

/***/ "QqgH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Row',{staticStyle:{"padding":"2vw 10vw 10vw 10vw"},attrs:{"type":"flex","justify":_vm.windowWidth > 1280 ? 'space-around' : 'space-between',"align":"middle"}},[(_vm.type === 'img-left')?_c('Col',{class:{'pad-top': _vm.isMobile},style:({ 'max-width': _vm.imageWidth })},[(_vm.image)?_c('img',{attrs:{"src":_vm.image,"width":"100%"}}):_vm._e(),_vm._v(" "),(_vm.component)?_c(_vm.component,{tag:"component",attrs:{"isMobile":_vm.isMobile,"windowWidth":_vm.windowWidth}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('Col',{staticClass:"content-section",staticStyle:{"max-width":"450px"}},[_c('h2',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._l((_vm.descriptions),function(desc,$index){return _c('p',{key:$index,staticClass:"content"},[_vm._v(_vm._s(desc))])}),_vm._v(" "),(_vm.cta)?_c('GetStartedButton',{attrs:{"arrow":true}}):_vm._e()],2),_vm._v(" "),(_vm.type === 'img-right')?_c('Col',{class:{'pad-top': _vm.isMobile},style:({ 'max-width': _vm.imageWidth })},[(_vm.image)?_c('img',{attrs:{"src":_vm.image,"width":"100%"}}):_vm._e(),_vm._v(" "),(_vm.component)?_c(_vm.component,{tag:"component",attrs:{"isMobile":_vm.isMobile,"windowWidth":_vm.windowWidth}}):_vm._e()],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QvMu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RIdP":
/***/ (function(module, exports, __webpack_require__) {

var $export     = __webpack_require__("cGkp")
  , $parseFloat = __webpack_require__("/p5N");
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', {parseFloat: $parseFloat});

/***/ }),

/***/ "RMiN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ro/S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GetStartedButton__ = __webpack_require__("Lehf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_pages__ = __webpack_require__("f6Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_platformComponents__ = __webpack_require__("Z1NO");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['isMobile', 'windowWidth'],
  components: { GetStartedButton: __WEBPACK_IMPORTED_MODULE_0__GetStartedButton__["a" /* default */] },
  data: function data() {
    return { loginUrl: "https://app.vuefinance.com/login", showModal: false, containerId: 'header', atTopOfPage: false, pages: __WEBPACK_IMPORTED_MODULE_1__services_pages__["a" /* default */], productDropdownIsOpen: false, componentList: __WEBPACK_IMPORTED_MODULE_2__services_platformComponents__["a" /* default */] };
  },
  mounted: function mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  created: function created() {
    this.handleScroll();
  },

  methods: {
    navigate: function navigate(name) {
      var vm = this;
      if (name === 'Get Early Access') {
        return;
      }
      vm.$router.push({ name: name });
    },
    openModal: function openModal() {
      this.showModal = true;
    },
    handleScroll: function handleScroll() {
      if (window.scrollY > 40) {
        this.atTopOfPage = true;
      } else {
        this.atTopOfPage = false;
      }
    },
    onDropdownChange: function onDropdownChange(state) {
      var vm = this;
      vm.productDropdownIsOpen = state;
    }
  }
});

/***/ }),

/***/ "Rute":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SKzV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GetStartedButton__ = __webpack_require__("Lehf");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { GetStartedButton: __WEBPACK_IMPORTED_MODULE_0__GetStartedButton__["a" /* default */] },
  props: {
    tone: { type: String, default: 'light' }
  }
});

/***/ }),

/***/ "SQIg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScheduleDemo_vue__ = __webpack_require__("XMI/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6310b12_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScheduleDemo_vue__ = __webpack_require__("lIFy");
function injectStyle (ssrContext) {
  __webpack_require__("pTwj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f6310b12"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScheduleDemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6310b12_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScheduleDemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SRpw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"ivu-card ivu-card-bordered lift-on-hover item-padding item-margin",staticStyle:{"width":"500px"},style:({ background: _vm.color }),attrs:{"to":{ name: _vm.route }}},[_c('Row',{staticClass:"content-area ivu-card-body",attrs:{"type":"flex","align":"middle","justify":"space-between"}},[_c('Col',{attrs:{"span":"20"}},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.content))])]),_vm._v(" "),_c('Col',{attrs:{"span":"4"}},[_c('Row',{attrs:{"type":"flex","justify":"end"}},[_c('Icon',{attrs:{"type":"arrow-right-c","size":"30"}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SURx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AggregationPage_vue__ = __webpack_require__("b4o8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33b87996_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AggregationPage_vue__ = __webpack_require__("hqxy");
function injectStyle (ssrContext) {
  __webpack_require__("Q0UO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AggregationPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33b87996_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AggregationPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SZXL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_pages__ = __webpack_require__("f6Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Hero__ = __webpack_require__("UfZ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SectionNavigation__ = __webpack_require__("6MC7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContentImageSection__ = __webpack_require__("n6LY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DemonstrationSection__ = __webpack_require__("LmGY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EmailSignupSection__ = __webpack_require__("1itW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AggressiveCTA__ = __webpack_require__("92J2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Hero: __WEBPACK_IMPORTED_MODULE_1__Hero__["a" /* default */], SectionNavigation: __WEBPACK_IMPORTED_MODULE_2__SectionNavigation__["a" /* default */], ContentImageSection: __WEBPACK_IMPORTED_MODULE_3__ContentImageSection__["a" /* default */], DemonstrationSection: __WEBPACK_IMPORTED_MODULE_4__DemonstrationSection__["a" /* default */], EmailSignupSection: __WEBPACK_IMPORTED_MODULE_5__EmailSignupSection__["a" /* default */], AggressiveCTA: __WEBPACK_IMPORTED_MODULE_6__AggressiveCTA__["a" /* default */] },
  props: ['isMobile', 'windowWidth'],
  data: function data() {
    var content = __WEBPACK_IMPORTED_MODULE_0__services_pages__["a" /* default */].assessments;
    return { content: content };
  }
});

/***/ }),

/***/ "ShJL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TMEZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScheduleButton__ = __webpack_require__("PyvK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GetStartedButton__ = __webpack_require__("Lehf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EmailListSignupForm__ = __webpack_require__("Hih6");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['isMobile'],
  components: { ScheduleButton: __WEBPACK_IMPORTED_MODULE_0__ScheduleButton__["a" /* default */], GetStartedButton: __WEBPACK_IMPORTED_MODULE_1__GetStartedButton__["a" /* default */], EmailListSignupForm: __WEBPACK_IMPORTED_MODULE_2__EmailListSignupForm__["a" /* default */] },
  data: function data() {
    return {
      loginUrl: "https://app.vuefinance.com/login"
    };
  }
});

/***/ }),

/***/ "TtJk":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("7Adc")
  , max       = Math.max
  , min       = Math.min;
module.exports = function(index, length){
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),

/***/ "Tuy/":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("+rzM")
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};

/***/ }),

/***/ "U0U0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__charts_ChangeIndicatorTable__ = __webpack_require__("4Ruh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CardHeader__ = __webpack_require__("M9NS");
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['isMobile'],
  components: { ChangeIndicatorTable: __WEBPACK_IMPORTED_MODULE_0__charts_ChangeIndicatorTable__["a" /* default */], CardHeader: __WEBPACK_IMPORTED_MODULE_1__CardHeader__["a" /* default */] },
  data: function data() {
    var baseValue = 2091830.28;
    return {
      baseValue: baseValue,
      tableData: [{ label: 'Last Month', value: baseValue - baseValue * 0.045 }, { label: 'Last Year', value: baseValue - baseValue * 0.18 }]
    };
  }
});

/***/ }),

/***/ "UXp/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PricingPage_vue__ = __webpack_require__("i+cT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb15bdaa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PricingPage_vue__ = __webpack_require__("/03a");
function injectStyle (ssrContext) {
  __webpack_require__("akF3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fb15bdaa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PricingPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb15bdaa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PricingPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UeQB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Row',{style:({ width: '100%' }),attrs:{"type":"flex","justify":"center","align":"middle"}},[_c('Col',{attrs:{"span":"24"}},[_c('h1',{class:{ red: _vm.baseValue < 0, 'table-green': _vm.baseValue > 0 },staticStyle:{"padding-bottom":"16px","text-align":"center"}},[_vm._v("\n      "+_vm._s(("$" + (_vm.commafy(_vm.baseValue))))+"\n    ")]),_vm._v(" "),_c('Table',{ref:"currentRowTable",attrs:{"columns":_vm.columns,"data":_vm.formattedTableData}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UfZ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hero_vue__ = __webpack_require__("DpAH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_311bfce1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hero_vue__ = __webpack_require__("yvvZ");
function injectStyle (ssrContext) {
  __webpack_require__("dUEd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hero_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_311bfce1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hero_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Vqvw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "W2hP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NetWorthCard_vue__ = __webpack_require__("XPCd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3faf7618_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NetWorthCard_vue__ = __webpack_require__("g1Iz");
function injectStyle (ssrContext) {
  __webpack_require__("QvMu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3faf7618"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NetWorthCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3faf7618_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NetWorthCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "W3U9":
/***/ (function(module, exports) {

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};

/***/ }),

/***/ "WXzC":
/***/ (function(module, exports) {

var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),

/***/ "WwqW":
/***/ (function(module, exports) {

module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),

/***/ "XKK6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__("UlOv");


/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Doughnut */],
  data: function data() {
    return {
      datacollection: {
        labels: ['Real Estate', 'Retirement', 'Cash', 'Public Securities', 'Private Securities'],
        datasets: [{
          backgroundColor: ['rgba(51, 153, 255, 0.95)', 'rgba(51, 153, 255, 0.70)', 'rgba(51, 153, 255, 0.40)', 'rgba(51, 153, 255, 0.20)', 'rgba(51, 153, 255, 0.05)'],
          data: [60, 20, 14, 4, 2]
        }]
      }
    };
  },
  mounted: function mounted() {
    var vm = this;
    vm.renderChart(vm.datacollection, {
      responsive: true,
      maintainAspectRatio: false,
      cutoutPercentage: 0,
      tooltips: {
        callbacks: {
          title: function title(tooltipItems, metadata) {
            var something = metadata.labels[tooltipItems[0].index];
            return '' + something;
          },
          label: function label(tooltipItem, metadata) {
            var data = metadata.datasets[0].data[tooltipItem.index];
            return ' ' + data + '%';
          }
        }
      }
    });
  }
});

/***/ }),

/***/ "XMI/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GetStartedButton__ = __webpack_require__("Lehf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ScheduleButton__ = __webpack_require__("PyvK");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['isMobile'],
  components: { GetStartedButton: __WEBPACK_IMPORTED_MODULE_0__GetStartedButton__["a" /* default */], ScheduleButton: __WEBPACK_IMPORTED_MODULE_1__ScheduleButton__["a" /* default */] }
});

/***/ }),

/***/ "XPCd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__charts_NetWorthChart__ = __webpack_require__("h1rt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CardHeader__ = __webpack_require__("M9NS");
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NetWorthCard',
  props: ['isMobile'],
  components: { NetWorthChart: __WEBPACK_IMPORTED_MODULE_0__charts_NetWorthChart__["a" /* default */], CardHeader: __WEBPACK_IMPORTED_MODULE_1__CardHeader__["a" /* default */] }
});

/***/ }),

/***/ "Xc+a":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("WwqW");
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AggregationPage__ = __webpack_require__("SURx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ValuationsPage__ = __webpack_require__("NGZt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AssessmentsPage__ = __webpack_require__("uuEf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Landingv2__ = __webpack_require__("i2gY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_PricingPage__ = __webpack_require__("UXp/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_FeaturesPage__ = __webpack_require__("kHRW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_TermsOfUsePage__ = __webpack_require__("hY9U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_PrivacyPolicyPage__ = __webpack_require__("aUP3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ClosedRegistration__ = __webpack_require__("GDP0");












__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior() {
    return { x: 0, y: 0 };
  },

  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Landingv2__["a" /* default */]
  }, {
    path: '/aggregation',
    name: 'Data Aggregation',
    component: __WEBPACK_IMPORTED_MODULE_2__components_AggregationPage__["a" /* default */]
  }, {
    path: '/valuations',
    name: 'Asset Valuations',
    component: __WEBPACK_IMPORTED_MODULE_3__components_ValuationsPage__["a" /* default */]
  }, {
    path: '/assessments',
    name: 'Dynamic Assessments',
    component: __WEBPACK_IMPORTED_MODULE_4__components_AssessmentsPage__["a" /* default */]
  }, {
    path: '/pricing',
    name: 'Pricing',
    component: __WEBPACK_IMPORTED_MODULE_6__components_PricingPage__["a" /* default */]
  }, {
    path: '/features',
    name: 'Features',
    component: __WEBPACK_IMPORTED_MODULE_7__components_FeaturesPage__["a" /* default */]
  }, {
    path: '/terms-of-use',
    name: 'Terms of Use',
    component: __WEBPACK_IMPORTED_MODULE_8__components_TermsOfUsePage__["a" /* default */]
  }, {
    path: '/privacy-policy',
    name: 'Privacy Policy',
    component: __WEBPACK_IMPORTED_MODULE_9__components_PrivacyPolicyPage__["a" /* default */]
  }, {
    path: '/closed-registration',
    name: 'Closed Registration',
    component: __WEBPACK_IMPORTED_MODULE_10__components_ClosedRegistration__["a" /* default */]
  }]
}));

/***/ }),

/***/ "Z1NO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages__ = __webpack_require__("f6Iv");


var platformComponents = ['aggregation', 'valuations', 'assessments'].map(function (i) {
  return __WEBPACK_IMPORTED_MODULE_0__pages__["a" /* default */][i];
});

/* harmony default export */ __webpack_exports__["a"] = (platformComponents);

/***/ }),

/***/ "ZWGY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Col',[_c('Row',{staticStyle:{"height":"6px","width":"24px"}},[_c('Icon',{attrs:{"type":"ios-minus-empty","size":25}})],1),_vm._v(" "),_c('Row',{staticStyle:{"height":"6px","padding-left":"5px","width":"24px"}},[_c('Icon',{attrs:{"type":"ios-minus-empty","size":25}})],1),_vm._v(" "),_c('Row',{staticStyle:{"height":"6px","padding-left":"5px","width":"24px"}},[_c('Icon',{attrs:{"type":"ios-minus-empty","size":25}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Zlf3":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),

/***/ "Zqmj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zvey":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Col',[_c('Hero',{attrs:{"title":_vm.title,"description":_vm.description,"backgroundImage":_vm.backgroundImage,"image":_vm.isMobile ? '/static/dashboard.png' : null,"contentWidth":"526px","imageWidth":"500px","minHeight":"690px","slant":_vm.isMobile,"isMobile":_vm.isMobile,"scrollOffset":0,"titleStyles":{ 'font-size': '2.2rem' }}}),_vm._v(" "),_c('PlatformComponentsList'),_vm._v(" "),_c('SecuritySection'),_vm._v(" "),_c('EmailSignupSection',{attrs:{"isMobile":_vm.isMobile}}),_vm._v(" "),_c('AggressiveCTA',{attrs:{"isMobile":_vm.isMobile}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZytV":
/***/ (function(module, exports, __webpack_require__) {

var has          = __webpack_require__("69rs")
  , toIObject    = __webpack_require__("gXjG")
  , arrayIndexOf = __webpack_require__("kVtx")(false)
  , IE_PROTO     = __webpack_require__("bDok")('IE_PROTO');

module.exports = function(object, names){
  var O      = toIObject(object)
    , i      = 0
    , result = []
    , key;
  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while(names.length > i)if(has(O, key = names[i++])){
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

/***/ }),

/***/ "aLLD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("iPQn") && !__webpack_require__("W3U9")(function(){
  return Object.defineProperty(__webpack_require__("vXbD")('div'), 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),

/***/ "aSSA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Row',{staticStyle:{"padding-bottom":"38px","padding-left":"18vw","padding-right":"18vw"},attrs:{"type":"flex","jsutify":"start","align":"top"}},_vm._l((_vm.content),function(section){return _c('div',[_c('h2',{staticClass:"section-title"},[_c('strong',[_vm._v(_vm._s(section.title))])]),_vm._v(" "),_c('div',_vm._l((section.content),function(paragraph){return (typeof paragraph === 'string')?_c('p',{staticClass:"content-item",class:{ 'no-margin': section.title === 'Contact Information' }},[_vm._v("\n        "+_vm._s(paragraph)+"\n      ")]):(paragraph.type === 'ul')?_c('ul',{staticClass:"content-item"},_vm._l((paragraph.items),function(listItem){return _c('li',[_vm._v(_vm._s(listItem))])})):(paragraph.type === 'i')?_c('p',{staticClass:"content-item"},[_c('i',[_vm._v(_vm._s(paragraph.content))])]):_vm._e()}))])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aUP3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyPage_vue__ = __webpack_require__("jEke");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6da91020_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyPage_vue__ = __webpack_require__("L8Mf");
function injectStyle (ssrContext) {
  __webpack_require__("bN/O")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6da91020"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6da91020_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "akF3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "b4o8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_pages__ = __webpack_require__("f6Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Hero__ = __webpack_require__("UfZ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SectionNavigation__ = __webpack_require__("6MC7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContentImageSection__ = __webpack_require__("n6LY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DemonstrationSection__ = __webpack_require__("LmGY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EmailSignupSection__ = __webpack_require__("1itW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AggressiveCTA__ = __webpack_require__("92J2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: { AggressiveCTA: __WEBPACK_IMPORTED_MODULE_6__AggressiveCTA__["a" /* default */], Hero: __WEBPACK_IMPORTED_MODULE_1__Hero__["a" /* default */], SectionNavigation: __WEBPACK_IMPORTED_MODULE_2__SectionNavigation__["a" /* default */], ContentImageSection: __WEBPACK_IMPORTED_MODULE_3__ContentImageSection__["a" /* default */], DemonstrationSection: __WEBPACK_IMPORTED_MODULE_4__DemonstrationSection__["a" /* default */], EmailSignupSection: __WEBPACK_IMPORTED_MODULE_5__EmailSignupSection__["a" /* default */] },
  props: ['windowWidth', 'isMobile'],
  data: function data() {
    var content = __WEBPACK_IMPORTED_MODULE_0__services_pages__["a" /* default */].aggregation;
    return { content: content };
  }
});

/***/ }),

/***/ "bDok":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("Tuy/")('keys')
  , uid    = __webpack_require__("WXzC");
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),

/***/ "bN/O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cGkp":
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__("+rzM")
  , core      = __webpack_require__("hC6b")
  , ctx       = __webpack_require__("Bxrf")
  , hide      = __webpack_require__("QoAr")
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , IS_WRAP   = type & $export.W
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE]
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
    , key, own, out;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if(own && key in exports)continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function(C){
      var F = function(a, b, c){
        if(this instanceof C){
          switch(arguments.length){
            case 0: return new C;
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if(IS_PROTO){
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;

/***/ }),

/***/ "cT2H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Row',{staticClass:"section-navigation",staticStyle:{"padding":"0 3vw 32px 3vw","margin-bottom":"28px"},attrs:{"type":"flex","justify":"start"}},[_c('Col',{attrs:{"span":"24"}},[_c('Row',{attrs:{"type":"flex","justify":"space-around"}},[_c('PageNavCard',{attrs:{"direction":"next","title":_vm.next.title,"content":_vm.next.content,"color":_vm.next.color,"route":_vm.next.route}}),_vm._v(" "),_c('PageNavCard',{attrs:{"direction":"prev","title":_vm.prev.title,"content":_vm.prev.content,"color":_vm.prev.color,"route":_vm.prev.route}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cxo1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Row',[_c('Hero',{attrs:{"contentWidth":"569px","isMobile":_vm.isMobile,"title":_vm.content.title,"description":_vm.content.description,"backgroundColor":_vm.content.backgroundColor,"image":_vm.content.image,"textShadow":false}}),_vm._v(" "),_c('ContentImageSection',{attrs:{"windowWidth":_vm.windowWidth,"title":_vm.content.problem.title,"descriptions":_vm.content.problem.descriptions,"image":_vm.content.problem.image,"type":"img-right"}}),_vm._v(" "),_c('ContentImageSection',{attrs:{"windowWidth":_vm.windowWidth,"title":_vm.content.solution.title,"descriptions":_vm.content.solution.descriptions,"image":_vm.content.solution.image,"component":_vm.content.solution.component,"type":!_vm.isMobile? 'img-left' : 'img-right'}}),_vm._v(" "),(_vm.content.demo)?_c('DemonstrationSection',{attrs:{"isMobile":_vm.isMobile,"windowWidth":_vm.windowWidth,"title":_vm.content.demo.title,"sections":_vm.content.demo.sections}}):_vm._e(),_vm._v(" "),_c('SectionNavigation',{attrs:{"current":_vm.content.id}}),_vm._v(" "),_c('EmailSignupSection',{attrs:{"isMobile":_vm.isMobile}}),_vm._v(" "),_c('AggressiveCTA',{attrs:{"isMobile":_vm.isMobile}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dKSF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dMvG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dUEd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "db+C":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("WwqW");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),

/***/ "ditZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dlME":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_platformComponents__ = __webpack_require__("Z1NO");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return { list: __WEBPACK_IMPORTED_MODULE_0__services_platformComponents__["a" /* default */] };
  }
});

/***/ }),

/***/ "dmJG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dy8G":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys       = __webpack_require__("ZytV")
  , enumBugKeys = __webpack_require__("LV4Q");

module.exports = Object.keys || function keys(O){
  return $keys(O, enumBugKeys);
};

/***/ }),

/***/ "e8hI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "emx8":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};

/***/ }),

/***/ "f6Iv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var platformComponents = {
  aggregation: {
    id: 'aggregation',
    title: 'Vue Finance - Data Aggregation',
    description: 'Vue Finances was engineered to pull values from the source of your financial data. This eliminates the need to aggregate data manually and provides you with a seamless way to visualize your portfolio.',
    icon: 'ios-ionic-outline',
    color: '#42368D',
    backgroundColor: 'linear-gradient(rgb(66, 54, 141), rgb(63, 53, 125))',
    // backgroundColor: '#2c3849',
    route: 'Data Aggregation',
    card: {
      title: 'Data Aggregation',
      description: 'We do the work of aggregating the values needed to generate your net-worth and value your assets.'
    },
    sectionNavigation: {
      next: {
        id: 'valuations',
        title: 'Asset Valuations',
        content: 'Now that you’ve pulled in the data you need, generate valuation for your assets and calculate your net worth.'
      },
      prev: {
        id: 'assessments',
        title: 'Dynamic Assessments',
        content: 'Learn how you can use your connected data to generate actionable financial reports.'
      }
    },
    problem: {
      title: 'Your Financial Data is Scattered',
      descriptions: ['As your portfolio grows, so does the difficulty of aggregating your finances. Even calculating your net worth can become a complex, time-intensive process when your financial information is widespread.'],
      image: '/static/aggregation-2.png'
    },
    solution: {
      title: 'We Bring it All Together',
      descriptions: ['Utilizing the data from financial institutions, valuation services, account management systems and more, we source everything you need to better understand your finances. Once connected, our system seamlessly pulls data and presents it to you in a way that\'s easy to understand.'],
      image: '/static/aggregation-3.png'
    },
    demo: {
      title: 'What you can do with Data Aggregation',
      sections: [{
        title: 'See all of your bank accounts in one place',
        descriptions: ['We integrate with over 14,000 financial institutions so you can see checking, brokerage, retirement, and trading, accounts all in one location.'],
        image: '/static/connect-accounts.png'
      }, {
        // title: 'Sync your financial data to and from your spreadsheets',
        title: 'Import values for your real estate portfolio',
        descriptions: ['Import the value of properties to see your real estate portfolio alongside your personal finances. Don\'t worry, if you own real estate through an LLC or trust, you specify its ownership.'],
        image: '/static/zillow-import.png'
      }, {
        title: 'Use any of our constantly growing list of integrations',
        descriptions: ['We\'re constantly building new integrations to help you visualize values for your real estate, businesses, crypto currencies, and more.'],
        image: '/static/integrations.png'
      }]
    }
  },
  valuations: {
    id: 'valuations',
    title: 'Vue Finance - Asset Valuations',
    description: 'Our software provides you with an instant and accurate valuation for each of your assets. You can now track the value of your assets with high precision and minimal effort.',
    icon: 'ios-settings',
    color: '#0F3D7E',
    backgroundColor: 'linear-gradient(rgb(16, 66, 138), rgb(15, 57, 115))',
    // backgroundColor: '#2c3849',
    route: 'Asset Valuations',
    image: null,
    card: {
      title: 'Asset Valuations',
      description: 'Define how to valuate your assets and we’ll do the number-crunching.'
    },
    sectionNavigation: {
      next: {
        id: 'assessments',
        title: 'Custom Assessments',
        content: 'Now that you can valuate your assets, create assessments to visualize your portfolio.'
      },
      prev: {
        id: 'aggregation',
        title: 'Data Aggregation',
        content: 'Connect to the source of your financial information to better valuate your net worth and assets.'
      }
    },
    problem: {
      title: 'Valuations on Autopilot',
      descriptions: ['Vue Finance eliminates the need to manually calculate the value of your assets and net worth.', 'Define a formula (or "expression") for any asset in your portfolio and we\'ll take care of the rest, providing you with valuations for each asset, on-demand.'],
      image: '/static/valuations-1.png'
    },
    solution: {
      title: 'Customizable & Extensible',
      descriptions: ['Utilize the value of other assets, and imported values from external resources, to seamlessly generate the worth of complex assets. Proven to be useful for valuating businesses and real estate.'],
      image: '/static/valuations-2.png'
    },
    demo: {
      title: 'What you can do with Valuations',
      sections: [{
        title: 'Nest Accounts under an entity',
        descriptions: ['Specify an account\'s ownership to gain a true view of ownership and liability across your portfolio. Use the "Sum of Accounts" valuation to generate a value for the parent entity.'],
        image: '/static/nested-accounts-with-formulas.png'
      }, {
        title: 'Create and track custom values ',
        descriptions: ['Create custom values that stay up-to-date and always accurate. You can use these values in your Assessments to create reports and insights.'],
        image: '/static/custom-values.png'
      }]
    }
  },
  assessments: {
    id: 'assessments',
    title: 'Vue Finance - Dynamic Assessments',
    description: 'We\'ve developed a better way for you to visualize your finances. Use Assessments to create custom and personalized reports to uncover the insights needed to grow your net worth.',
    icon: 'ios-pie-outline',
    color: 'rgb(27, 162, 142)',
    backgroundColor: 'linear-gradient(rgb(27, 162, 142), rgb(23, 148, 129))',
    // backgroundColor: 'linear-gradient(rgb(22, 112, 99), rgb(32, 92, 82)) 0% 0% / cover',
    // color: 'rgb(43, 168, 150)',
    // backgroundColor: 'linear-gradient(rgb(43, 168, 150), rgb(23, 148, 129))',
    route: 'Dynamic Assessments',
    // image: '/static/assessments-hero.png',
    card: {
      title: 'Dynamic Assessments',
      description: 'Create custom reports and assessments that help grow your net-worth.'
    },
    sectionNavigation: {
      next: {
        id: 'aggregation',
        title: 'Data Aggregation',
        content: 'Connect to the source of your financial information to create more accurate and relevant assessments.'
      },
      prev: {
        id: 'valuations',
        title: 'Asset Valuations',
        content: 'Use Asset Valuations to calculate the value of your assets and build more robust reports.'
      }
    },
    problem: {
      // 'You need anwers'
      title: 'You Have Questions...',
      descriptions: ['Before you can make an investment, redistribute your portfolio, or make any other imporant financial decision, you need to have a clear picture of your finances and know where you stand.', 'What is your porfolio distribution? How much cash do you have on hand? Which assets are contributing the most to your net worth? Is your investment strategy paying off?'],
      image: '/static/assessments-1.png'
    },
    solution: {
      title: 'We Provide Answers',
      descriptions: ['With a click of a button you can dive deep into your financial data and uncover the insights you need to make confident, data-driven financial descisions.', 'Build reports that are relevant and imporant to you. Once created, your assessments stay up to date with the source of your financial information and are accessible where and when you need it most.'],
      image: '/static/assessments-2.png'
    },
    demo: {
      title: 'What you can do with Assessments',
      sections: [{
        // title: 'Sync your financial data to and from your spreadsheets',
        title: 'See your portfolio distribution',
        descriptions: ['Once all of your portfolio values are imported, you can use pie charts to visualize your portfolio distribution and more.'],
        component: 'PortfolioDistCard'
      }, {
        title: 'Track your net worth over time',
        descriptions: ['Use change indicators to see the percent change of a value given a time period, for example your net worth over a month or year.'],
        component: 'NetWorthIndicator'
      }, {
        title: 'Compare the performance of multiple investments',
        descriptions: ['Use line charts to see any value in your portfolio over time. In this case, comparing the ROI of two investment sectors in your portfolio.'],
        component: 'REvMarketCard'
      }]
    }
  }
  /*eslint-disable */
  // support: {
  //   id: 'support',
  //   title: 'Vue Finance - Hands on Support',
  //   description: '',
  //   icon: 'help-buoy',
  //   color: '#257D77',
  //    backgroundColor: 'linear-gradient(#257D77, #257D77)',
  //   route: 'Hands-on Support',
  //   image: '/static/hands-on-support-hero.png',
  //   card: {
  //     title: 'Hands-on Support',
  //     description: 'Have a team of Solution Engineers by your side helping you configure your portfolio and create in-depth reports.',
  //   },
  // },
};

/* harmony default export */ __webpack_exports__["a"] = (platformComponents);

/***/ }),

/***/ "fX05":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{attrs:{"id":"footer"}},[_c('Row',{attrs:{"type":"flex","justify":"space-between"}},[_c('Col',[_c('div',{staticClass:"footer-col",attrs:{"type":"flex","justify":"start"}},[_c('h3',[_vm._v("HOW IT WORKS")]),_vm._v(" "),_c('p',[_c('router-link',{attrs:{"to":{ name: 'Data Aggregation' }}},[_vm._v("Data Aggregation")])],1),_vm._v(" "),_c('p',[_c('router-link',{attrs:{"to":{ name: 'Asset Valuations' }}},[_vm._v("Asset Valuations")])],1),_vm._v(" "),_c('p',[_c('router-link',{attrs:{"to":{ name: 'Dynamic Assessments' }}},[_vm._v("Dynamic Assessments")])],1)])]),_vm._v(" "),_c('Col',[_c('div',{staticClass:"footer-col",attrs:{"type":"flex","justify":"start"}},[_c('h3',[_vm._v("PRODUCT")]),_vm._v(" "),_c('p',[_c('router-link',{attrs:{"to":{ name: 'Features' }}},[_vm._v("Features")])],1),_vm._v(" "),_c('p',[_c('router-link',{attrs:{"to":{ name: 'Pricing' }}},[_vm._v("Pricing")])],1)])]),_vm._v(" "),_c('Col',[_c('div',{staticClass:"footer-col",attrs:{"type":"flex","justify":"start"}},[_c('h3',[_vm._v("LEGAL")]),_vm._v(" "),_c('p',[_c('router-link',{attrs:{"to":{ name: 'Terms of Use' }}},[_vm._v("Terms of Use")])],1),_vm._v(" "),_c('p',[_c('router-link',{attrs:{"to":{ name: 'Privacy Policy' }}},[_vm._v("Privacy Policy")])],1)])]),_vm._v(" "),_c('Col',[_c('div',{staticClass:"footer-col",attrs:{"type":"flex","justify":"start"}},[_c('h3',[_vm._v("COMPANY")]),_vm._v(" "),_c('p',[_vm._v("Vue Finance, Inc.")]),_vm._v(" "),_c('p',[_vm._v("260 1st Ave S Suite 200")]),_vm._v(" "),_c('p',[_vm._v("St. Petersburg, Florida 33701")])])]),_vm._v(" "),_c('Col',{staticStyle:{"margin-top":"32px"},attrs:{"span":"24"}},[_c('Row',{staticStyle:{"padding":"8px 16px","padding-top":"0","margin-bottom":"16px"},attrs:{"type":"flex","justify":"space-between","align":"middle"}},[_c('Col',{staticClass:"sub-footer-actions"},[_c('Row',{attrs:{"type":"flex","align":"middle"}},[_c('EmailListSignupForm')],1)],1),_vm._v(" "),_c('Col',{staticClass:"sub-footer-actions"},[_c('GetStartedButton')],1)],1)],1)],1),_vm._v(" "),_c('Row',{staticStyle:{"padding":"16px"},attrs:{"type":"flex","align":"middle","justify":"center"}},[_c('small',[_vm._v("Copyright © 2018 Vue Finance, Inc. All rights reserved.")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "g1Iz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{style:({ width: _vm.isMobile ? '300px' : '434px' })},[_c('CardHeader',{attrs:{"slot":"title","title":"Net Worth"},slot:"title"}),_vm._v(" "),_c('Row',{staticClass:"feature-card",attrs:{"type":"flex","justify":"center","align":"middle"}},[_c('net-worth-chart',{staticStyle:{"width":"100%","height":"100%"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gXjG":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("4JPz")
  , defined = __webpack_require__("Zlf3");
module.exports = function(it){
  return IObject(defined(it));
};

/***/ }),

/***/ "gZvG":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("cGkp")
  , defined = __webpack_require__("Zlf3")
  , fails   = __webpack_require__("W3U9")
  , spaces  = __webpack_require__("qTrL")
  , space   = '[' + spaces + ']'
  , non     = '\u200b\u0085'
  , ltrim   = RegExp('^' + space + space + '*')
  , rtrim   = RegExp(space + space + '*$');

var exporter = function(KEY, exec, ALIAS){
  var exp   = {};
  var FORCE = fails(function(){
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if(ALIAS)exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function(string, TYPE){
  string = String(defined(string));
  if(TYPE & 1)string = string.replace(ltrim, '');
  if(TYPE & 2)string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;

/***/ }),

/***/ "h1rt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__("UlOv");


/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Line */],
  data: function data() {
    return {
      datacollection: {
        labels: ['1/1/2015', '6/1/2015', '1/1/2016', '6/1/2016', '1/1/2017', '6/1/2017'],
        datasets: [{
          label: 'Net Worth',
          backgroundColor: 'rgba(51, 153, 255, 0.20)',
          borderColor: 'rgba(51, 153, 255, 0.90)',
          data: [250000, 255000, 270000, 268000, 279000, 295000]
        }]
      }
    };
  },
  mounted: function mounted() {
    var vm = this;
    vm.renderChart(vm.datacollection, {
      responsive: true,
      maintainAspectRatio: false,
      legend: { display: false },
      lineTension: 0,
      tooltips: {
        callbacks: {
          title: function title(tooltipItems) {
            return '' + tooltipItems[0].xLabel;
          },
          label: function label(tooltipItem) {
            return '$' + tooltipItem.yLabel.toLocaleString('currency');
          }
        }
      },
      scales: {
        yAxes: [{
          ticks: {
            callback: function callback(value) {
              return '$' + value.toLocaleString('currency');
            },
            max: 300000,
            min: 225000,
            stepSize: 25000
          }
        }]
      }
    });
  }
});

/***/ }),

/***/ "hC6b":
/***/ (function(module, exports) {

var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),

/***/ "hY9U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsOfUsePage_vue__ = __webpack_require__("0ZDD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ae563c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsOfUsePage_vue__ = __webpack_require__("t1KY");
function injectStyle (ssrContext) {
  __webpack_require__("OPj5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7ae563c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsOfUsePage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ae563c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsOfUsePage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hph6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: { content: Array }
});

/***/ }),

/***/ "hqxy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Row',[_c('Hero',{attrs:{"slant":true,"isMobile":_vm.isMobile,"title":_vm.content.title,"description":_vm.content.description,"backgroundColor":_vm.content.backgroundColor,"image":_vm.content.image,"textShadow":false}}),_vm._v(" "),_c('ContentImageSection',{attrs:{"windowWidth":_vm.windowWidth,"title":_vm.content.problem.title,"descriptions":_vm.content.problem.descriptions,"image":_vm.content.problem.image,"type":"img-right"}}),_vm._v(" "),_c('ContentImageSection',{attrs:{"windowWidth":_vm.windowWidth,"title":_vm.content.solution.title,"descriptions":_vm.content.solution.descriptions,"image":_vm.content.solution.image,"type":!_vm.isMobile? 'img-left' : 'img-right',"imageWidth":"450px"}}),_vm._v(" "),(_vm.content.demo)?_c('DemonstrationSection',{attrs:{"windowWidth":_vm.windowWidth,"isMobile":_vm.isMobile,"title":_vm.content.demo.title,"sections":_vm.content.demo.sections}}):_vm._e(),_vm._v(" "),_c('SectionNavigation',{attrs:{"current":_vm.content.id}}),_vm._v(" "),_c('EmailSignupSection',{attrs:{"isMobile":_vm.isMobile}}),_vm._v(" "),_c('AggressiveCTA',{attrs:{"isMobile":_vm.isMobile}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "i+cT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PricingPlanCard__ = __webpack_require__("vnJH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Hero__ = __webpack_require__("UfZ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_faqs__ = __webpack_require__("/c8C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_pricingPlans__ = __webpack_require__("/6mk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ScheduleButton__ = __webpack_require__("PyvK");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['isMobile'],
  components: { PricingPlanCard: __WEBPACK_IMPORTED_MODULE_0__PricingPlanCard__["a" /* default */], Hero: __WEBPACK_IMPORTED_MODULE_1__Hero__["a" /* default */], ScheduleButton: __WEBPACK_IMPORTED_MODULE_4__ScheduleButton__["a" /* default */] },
  data: function data() {
    return {
      showAnnual: true,
      faqs: __WEBPACK_IMPORTED_MODULE_2__services_faqs__["a" /* default */],
      pricingPlans: __WEBPACK_IMPORTED_MODULE_3__services_pricingPlans__["a" /* default */]
    };
  }
});

/***/ }),

/***/ "i2gY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Landingv2_vue__ = __webpack_require__("D3Ap");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9951ec10_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Landingv2_vue__ = __webpack_require__("Zvey");
function injectStyle (ssrContext) {
  __webpack_require__("4ez0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9951ec10"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Landingv2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9951ec10_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Landingv2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iPQn":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("W3U9")(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),

/***/ "jCPM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jEke":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Hero__ = __webpack_require__("UfZ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DenseContent__ = __webpack_require__("1uhW");
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Hero: __WEBPACK_IMPORTED_MODULE_0__Hero__["a" /* default */], DenseContent: __WEBPACK_IMPORTED_MODULE_1__DenseContent__["a" /* default */] },
  data: function data() {
    return {
      terms: [{
        title: 'Privacy Policy',
        content: ['Last updated: August 6, 2018']
      }, {
        content: ['This document (“Privacy Policy”) describes how Vue Finance, Inc. (“Vue Finance”)  collects, uses, and discloses information about you when you use Vue Finance’s products and services. This policy applies to personal information we collect when you sign up for Vue Finance; when you access or use our website, products, or services (collectively, the “Site”); or when you otherwise interact with us, including through e-mail, text and other electronic messages. It does not apply to information collected by (i) us offline or through any other means not described herein, or (ii) any third party, including through any application or content (including advertising) that may link to or be accessible from our Site.', 'This Privacy Policy refers to personal information which is information that can be associated with a specific person and used to identify that person. Personal information does not include information that has been anonymized so that it does not identify a specific user, which may be used for any legal purpose.']
      }, {
        title: 'About Vue Finance',
        content: ['Vue Finance operates a website and series of web-based applications designed to help you aggregate and assess your financial data. Some of our products and services may be available for free without registering as a user on our site; other products and services require registering as a user on our system; and other products and services may involve certain fees. Please also reference our Terms of Use for more information on your rights as a Vue Finance user.']
      }, {
        title: 'Guiding Principles',
        content: ['Vue Finance aims to give users the insights and information they need to make important financial decisions confidently. Although we stride to make the Site as simple and easy to use as possible, we prioritize privacy and security over usability. With each additional feature and product, we make sure to uphold the highest standard of security and privacy.', 'We will not disclose your personal information to anyone unless it is required by law, at your direction, or is permitted by law and necessary to provide you with our services. We have not, and will not, sell your personal information to anyone.']
      }, {
        title: 'Information We Collect',
        content: ['To become a registered user on Vue Finance, you will use a series of online forms to create a user account on our systems. Vue Finance may ask for some personal information when you create a user account, including contact information and a password, which is used to protect your user account from unauthorized access. Your contact and login information is considered non-public personal information. Vue Finance will not disclose non-public personal information about its users, except as required and permitted by law, and it restricts access to non-public personal information about users to certain employees who require that information in order to maintain and operate Vue Finance’s systems.', 'Vue Finance may ask for other personal information in order to provide additional services and products to you. Some of these services may require entering into additional agreements or contracts, as discussed below.', 'Vue Finance stores, processes, and maintains data related to your user account in order to provide various services and products to you. Our uses for this data are described below.', 'Vue Finance also uses standard web analytics tools to gather site usage information for the purpose of improving user experience. As part of this web analytics activity, Vue Finance may place cookies on users’ computers. Vue Finance may also place cookies on users’ computers to enable certain Site features. Users who block cookies may not be able to take advantage of all Site functionality. Additionally, for specific sites or applications, Vue Finance may use web analytics to track usage to confirm compliance with the terms of use of those sites or applications.', 'We may collect your usage information about how you use the Site, including your access times, location, browser types and language, and Internet Protocol addresses. We may collect device-specific information when you access our Site, including your hardware model, operating system and version, unique device identifiers, mobile network information, and information about the device’s interaction with our Site.', 'Below is a list of third party service providers currently used by Vue Finance but may not include all cookies or third party service providers. In addition, the below list of cookies and third party service providers is subject to change at any time.', {
          type: 'ul',
          items: ['Google Analytics: https://policies.google.com/privacy', 'Drift: https://www.drift.com/privacy-policy/', 'Elevio: https://elev.io/legal/privacy-policy']
        }]
      }, {
        title: 'Children’s Privacy',
        content: ['The Site is not directed at children under the age of 13. We operate our websites in compliance with the Children’s Online Privacy Protection Act and will not knowingly collect or use personally identifiable information from anyone under 13.']
      }, {
        title: 'Use of Information',
        content: ['Vue Finance uses and maintains user information to provide our products and services to you and to help improve these products and services in the future.', 'Vue Finance’s systems process the information you provide us for various purposes, including displaying the information to you, delivering related content, performing analysis on your financial data, and other purposes relating to Vue Finance’s products and services.', 'Vue Finance may send you information related to your user account or our products and services. If you decide at any time that you no longer wish to receive such communications from us, please follow the “unsubscribe” instructions provided in the communications.', 'We may also use information about you (i) to track and analyze trends and usage in connection with our Site; (ii) to process and deliver contest and promotion entries and rewards; (iii) to protect our rights or property; (iv) to compare information for accuracy; (v) to verify your identity; (vi) to investigate and prevent fraud or other illegal activities; and (vii) for any other purpose disclosed to you in connection with our Site.', 'Additionally, we use information that we collect about you or that you provide to us, including any personal information:', {
          type: 'ul',
          items: ['To provide you with information, products or services that you request from us.', 'To fulfill any other purpose for which you provide it.', 'To provide you with notices about your user account/subscription, including expiration and renewal notices.', 'To carry out our obligations and enforce our rights arising from any contracts entered into between you and us, including for billing and collection.', 'To notify you about changes to our Site.', 'In any other way we may describe when you provide the information.', 'For any other purpose with your consent.']
        }, 'We may use the information we have collected from you to enable us to display advertisements to our advertisers’ target audiences.', 'We may use third-party service providers to process and store personal information in the United States and other countries.']
      }, {
        title: 'Information Sharing and Onward Transfer',
        content: ['We do not sell, rent, or otherwise share your personal information with any third parties except as permitted or required by law.', 'We may share personal information about you as follows:', {
          type: 'ul',
          items: ['To our subsidiaries and affiliates.', 'To contractors, service providers and other third parties we use to support our business and who are bound by contractual obligations to keep personal information confidential and use it only for the purposes for which we disclose it to them.', 'To comply with any court order, law or legal process, including to respond to any government or regulatory request.', 'To enforce or apply our terms of use, available at https://vuefinance.com/terms-of-use/, and other agreements, including for billing and collection purposes.', 'If we believe disclosure is necessary or appropriate to protect the rights, property, or safety of Vue Finance, our customers or others. This includes exchanging information with other companies and organizations for the purposes of fraud protection and credit risk reduction.', 'To a buyer or other successor in the event of a merger, divestiture, restructuring, reorganization, dissolution or other sale or transfer of some or all of Vue Finance assets, whether as a going concern or as part of bankruptcy, liquidation or similar proceeding, in which personal information held by Vue Finance about our users is among the assets transferred.', 'To fulfill the purpose for which you provide it.', 'With your consent or direction.']
        }, 'We may also share non-personally identifiable information (aggregated or otherwise) with third parties for any reason.']
      }, {
        title: 'Information Security',
        content: ['We take reasonable measures to safeguard the security of your personal information with industry-standard physical, electronic, and managerial procedures. The safety and security of your personal information also depends on you. Where we have given you (or where you have chosen) a password for access to certain parts of our Site, you are responsible for keeping this password confidential. We ask you not to share your password with anyone.', 'Unfortunately, the transmission of information via the internet is not completely secure. Although we do our best to protect your personal information, we cannot guarantee the security of your personal information transmitted to or through our Site. Any transmission of personal information is at your own risk. We are not responsible for circumvention of any privacy settings or security measures contained on or within the Site.']
      }, {
        title: 'Vue Finance Integrations',
        content: ['Vue Finance offers a service that gives users insights into their current financial position of assets and investment located elsewhere, such as at an online brokerage or a other online investor\'s portal.', 'Using these connections (“Integrations”) are completely optional, but sometimes require a user to provide our systems with private information to allow our systems to login and retrieve the information located on the third party’s systems.', 'Integrations will retrieve information about your investments or assets (such as names, values, trades, transfers, transactions, and other information) and store it on our systems. This information will be used in ways described previously.', 'We extend the same level of information security to this information (such as encryption, limitation of access by Vue Finance personnel, and other measures) as to other personal information on our systems.', 'At any time, you may delete this data from our system by using the appropriate links in the Accounts management area on our website. This will delete all information from our servers; however, statistics related to aggregating this data with other users’ portfolios (such as the average value of all Vue Finance assets) may remain on our servers.']
      }, {
        title: 'Data Retention',
        content: ['We store the information we collect about you for as long as is necessary for the purpose(s) for which we originally collected it. We may retain certain information for legitimate business purposes or as required by law.']
      }, {
        title: 'Transfer of Information to the U.S. and Other Countries',
        content: ['Vue Finance is based in the United States and we process and store information in the U.S.. As such, we and our service providers may transfer your information to, or store or access it in, jurisdictions that may not provide equivalent levels of data protection as your home jurisdiction. We will take steps to ensure that your personal data receives an adequate level of protection in the jurisdictions in which we process it.']
      }, {
        title: 'Residents of the European Economic Area',
        content: ['If you are a resident of the European Economic Area (“EEA”), you have certain rights and protections under the law regarding the processing of your personal data.', { type: 'i', content: 'Legal Basis for Processing' }, 'If you are a resident of the EEA, when we process your personal data we will only do so in the following situations:', {
          type: 'ul',
          items: ['We need to use your personal data to perform our responsibilities under our contract with you (e.g., providing the services you have requested).', 'We have a legitimate interest in processing your personal data. For example, we may process your personal data to send you marketing communications, to communicate with you about changes to our services, and to provide, secure, and improve our services.', 'You have given your consent to the processing of your personal data for one or more specific purposes.']
        }, { type: 'i', content: 'Data Subject Requests' }, 'If you are a resident of the EEA, you have the right to access personal data we hold about you and to ask that your personal data be corrected, erased, or transferred. You may also have the right to object to, or request that we restrict, certain processing. If you would like to exercise any of these rights, you may contact us at support@vuefinance.com.', { type: 'i', content: 'Questions or Complaints' }, 'If you are a resident of the EEA and have a concern about our processing of personal data that we are not able to resolve, you have the right to lodge a complaint with the data privacy authority where you reside. For contact details of your local Data Protection Authority, please see: http://ec.europa.eu/justice/data-protection/article-29/structure/data-protection-authorities/index_en.htm.']
      }, {
        title: 'Your Choices As a User',
        content: ['You may delete your Vue Finance user account by emailing support@vuefinance.com. We will endeavor to act on these deletion requests as soon as reasonably practicable.', 'Deletions take effect when we act on them. Residual information related to your user account may remain for some time on our servers. Some areas of Vue Finance’s website and some of Vue Finance’s services will not be available to you unless you choose to share certain personal information (such as Integrations, which requires access to third party’s systems).', 'Using the “User Profile” area of our website, you may delete or change the personal information that you have previously provided the Vue Finance. Where our “User Profile” tools do not allow you to delete or alter information, you may request such changes by emailing support@vuefinance.com. As described above, we will endeavor to act on these requests as soon as reasonably practicable, and residual information may remain on our servers. However, we may retain such information, as well as any data related to your trades, in accordance with applicable laws.']
      }, {
        title: 'Third Party Links',
        content: ['Vue Finance websites may contain links to other sites, some of which are not owned by Vue Finance. Vue Finance is not responsible for the security or privacy practices of non-Vue Finance sites, the products or services offered by such sites, or the content appearing at such sites. Likewise, Vue Finance does not endorse any of the products or services marketed at non-Vue Finance sites.', 'Vue Finance prohibits the framing of any materials available through the Vue Finance websites and unauthorized hypertext links to Vue Finance’s websites. Vue Finance reserves the right to disconnect or otherwise disable any unauthorized frames or hypertext links.']
      }, {
        title: 'Changes To This Policy',
        content: ['We may update, amend, revise or otherwise change this Privacy Policy from time to time. We will post any Privacy Policy changes on this page and, if the changes are substantial, we may provide a more prominent notice (including, for certain services, email notification of Privacy Policy changes). Each version of this Privacy Policy will be identified at the top of the page by its effective date. Your continued use of the Site constitutes your acceptance of the then-effective Privacy Policy. We encourage you to review the Privacy Policy whenever you access our services or otherwise interact with us to stay informed about our information practices and the choices available to you.']
      }, {
        title: 'More Information',
        content: ['If you have questions or comments about this Privacy Policy, please email us at support@vuefinance.com.']
      }]
    };
  }
});

/***/ }),

/***/ "kAHB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GetStartedButton__ = __webpack_require__("Lehf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EmailListSignupForm__ = __webpack_require__("Hih6");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { GetStartedButton: __WEBPACK_IMPORTED_MODULE_0__GetStartedButton__["a" /* default */], EmailListSignupForm: __WEBPACK_IMPORTED_MODULE_1__EmailListSignupForm__["a" /* default */] }
});

/***/ }),

/***/ "kHRW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeaturesPage_vue__ = __webpack_require__("BrGd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c0ef18a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FeaturesPage_vue__ = __webpack_require__("Hftg");
function injectStyle (ssrContext) {
  __webpack_require__("mJ03")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9c0ef18a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeaturesPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c0ef18a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FeaturesPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kVtx":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("gXjG")
  , toLength  = __webpack_require__("FZMV")
  , toIndex   = __webpack_require__("TtJk");
module.exports = function(IS_INCLUDES){
  return function($this, el, fromIndex){
    var O      = toIObject($this)
      , length = toLength(O.length)
      , index  = toIndex(fromIndex, length)
      , value;
    // Array#includes uses SameValueZero equality algorithm
    if(IS_INCLUDES && el != el)while(length > index){
      value = O[index++];
      if(value != value)return true;
    // Array#toIndex ignores holes, Array#includes - not
    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
      if(O[index] === el)return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

/***/ }),

/***/ "lFLZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('VueHeader',{attrs:{"windowWidth":_vm.windowWidth,"isMobile":_vm.isMobile}}),_vm._v(" "),_c('div',[_c('router-view',{attrs:{"windowWidth":_vm.windowWidth,"isMobile":_vm.isMobile}})],1),_vm._v(" "),_c('VueFooter',{attrs:{"isMobile":_vm.isMobile}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lIFy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Row',{staticStyle:{"padding":"10vh 5vw"},attrs:{"type":"flex","id":"getting-started","justify":"space-around","align":"middle"}},[_c('Col',{staticClass:"item",staticStyle:{"width":"420px"}},[_c('Row',{staticStyle:{"text-align":"center"},attrs:{"type":"flex","justify":"center"}},[_c('h1',{staticStyle:{"padding-bottom":"8px","font-size":"2rem"}},[_vm._v("Schedule a Demo!")]),_vm._v(" "),_c('h2',{staticStyle:{"padding-bottom":"16px"}},[_vm._v("Schedule a time with our team to learn more about Vue Finance and how we help you "),_c('strong',[_vm._v("be more effective financially")]),_vm._v(".")]),_vm._v(" "),_c('ScheduleButton',{attrs:{"title":"Schedule a Demo","eventType":"demo","isMobile":_vm.isMobile}}),_vm._v(" "),_c('GetStartedButton',{staticStyle:{"margin-left":"4px"},attrs:{"type":"ghost","title":"Get Started","arrow":true}})],1)],1),_vm._v(" "),_c('Col',{staticClass:"item"},[_c('img',{style:({ 'max-width': _vm.isMobile ? '100%' : '550px' }),attrs:{"src":"/static/dashboard.png"}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lPXq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AssetTypesSection_vue__ = __webpack_require__("vpbU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bb98c7c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AssetTypesSection_vue__ = __webpack_require__("zI9j");
function injectStyle (ssrContext) {
  __webpack_require__("dKSF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5bb98c7c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AssetTypesSection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bb98c7c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AssetTypesSection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ll94":
/***/ (function(module, exports) {

module.exports = {"_args":[["vue-chartjs@3.0.2","/Users/kevinmircovich/Documents/code/projects/vue-finance-landing"]],"_from":"vue-chartjs@3.0.2","_id":"vue-chartjs@3.0.2","_inBundle":false,"_integrity":"sha512-m6ItjL8o3ff4JpbF083RzZ4KPiNBFsqMKmWCcAtlisOdm1vvB/9mUDJePmxYKJkvl2AcpvLPiH1cUrhq46r8vA==","_location":"/vue-chartjs","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"vue-chartjs@3.0.2","name":"vue-chartjs","escapedName":"vue-chartjs","rawSpec":"3.0.2","saveSpec":null,"fetchSpec":"3.0.2"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/vue-chartjs/-/vue-chartjs-3.0.2.tgz","_spec":"3.0.2","_where":"/Users/kevinmircovich/Documents/code/projects/vue-finance-landing","author":{"name":"Jakub Juszczak","email":"jakub@posteo.de"},"browserify":{"transform":["babelify"]},"bugs":{"url":"https://github.com/apertureless/vue-chartjs/issues"},"contributors":[{"name":"Thorsten Lünborg","url":"https://github.com/LinusBorg"},{"name":"Juan Carlos Alonso","url":"https://github.com/jcalonso"}],"dependencies":{"lodash.merge":"^4.6.0"},"description":"Vue.js wrapper for chart.js for creating beautiful charts.","devDependencies":{"@babel/cli":"^7.0.0-beta.31","@babel/core":"^7.0.0-beta.31","@babel/preset-env":"^7.0.0-beta.31","@babel/preset-stage-2":"^7.0.0-beta.31","babel-loader":"8.0.0-beta.0","chai":"^3.5.0","chart.js":"2.7.0","chromedriver":"^2.28.0","connect-history-api-fallback":"^1.1.0","cross-env":"^3.2.4","cross-spawn":"^5.1.0","css-loader":"^0.28.0","eslint":"^3.19.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.7.1","eslint-plugin-html":"^2.0.1","eslint-plugin-import":"^2.2.0","eslint-plugin-node":"^4.2.2","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^3.0.1","file-loader":"^0.10.1","friendly-errors-webpack-plugin":"^1.6.1","function-bind":"^1.0.2","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.4","inject-loader":"^3.0.0","isparta":"^4.0.0","jasmine-core":"^2.5.2","json-loader":"^0.5.4","karma":"^1.5.0","karma-coverage":"^1.1.1","karma-jasmine":"^1.0.2","karma-mocha":"^1.2.0","karma-phantomjs-launcher":"^1.0.4","karma-phantomjs-shim":"^1.4.0","karma-sinon-chai":"^1.2.0","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.30","karma-webpack":"2","lolex":"^1.6.0","mocha":"^3.1.0","nightwatch":"^0.9.14","opn":"^5.1.0","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.13","portfinder":"^1.0.13","selenium-server":"^3.3.1","shelljs":"^0.7.7","sinon":"^2.1.0","sinon-chai":"^2.9.0","url-loader":"^0.5.8","vue":"2.5.2","vue-hot-reload-api":"2.1.0","vue-html-loader":"^1.2.4","vue-loader":"^13.3.0","vue-style-loader":"3.0.1","vue-template-compiler":"2.5.2","webpack":"^3.7.1","webpack-dev-middleware":"^1.10.1","webpack-hot-middleware":"^2.17.1","webpack-merge":"^4.1.0"},"engines":{"node":">=6.9.0","npm":">= 3.0.0"},"files":["src","dist","es"],"greenkeeper":{"ignore":["extract-text-webpack-plugin","karma-webpack","webpack","webpack-merge"]},"homepage":"http://vue-chartjs.org","jsnext:main":"es/index.js","keywords":["ChartJs","Vue","Visualisation","Wrapper","Charts"],"license":"MIT","main":"dist/vue-chartjs.js","maintainers":[{"name":"Jakub Juszczak","email":"jakub@posteo.de","url":"http://www.jakubjuszczak.de"}],"module":"es/index.js","name":"vue-chartjs","peerDependencies":{"chart.js":"2.7.x"},"repository":{"type":"git","url":"git+ssh://git@github.com/apertureless/vue-chartjs.git"},"scripts":{"build":"yarn run release && yarn run build:es","build:es":"cross-env BABEL_ENV=es babel src --out-dir es","dev":"node build/dev-server.js","e2e":"node test/e2e/runner.js","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","prepublishOnly":"yarn run lint && yarn run test && yarn run build","release":"webpack --progress --hide-modules --config  ./build/webpack.release.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.min.js","test":"npm run unit","unit":"karma start test/unit/karma.conf.js --single-run"},"unpkg":"dist/vue-chartjs.min.js","version":"3.0.2"}

/***/ }),

/***/ "mJ03":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n6LY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentImageSection_vue__ = __webpack_require__("NEk/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87afee18_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentImageSection_vue__ = __webpack_require__("QqgH");
function injectStyle (ssrContext) {
  __webpack_require__("dMvG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-87afee18"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentImageSection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87afee18_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentImageSection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nsN4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{style:({ width: _vm.isMobile ? '300px' : '434px' })},[_c('CardHeader',{key:"brokerage",attrs:{"slot":"title","title":"ROI: Real Estate vs Securities"},slot:"title"}),_vm._v(" "),_c('Row',{staticClass:"feature-card",attrs:{"type":"flex","justify":"center","align":"middle"}},[_c('REvMarket',{staticStyle:{"height":"100%","width":"100%"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oAcl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ContentImageSection__ = __webpack_require__("n6LY");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { ContentImageSection: __WEBPACK_IMPORTED_MODULE_0__ContentImageSection__["a" /* default */] },
  props: {
    windowWidth: Number,
    isMobile: Boolean,
    title: String,
    sections: Array
  },
  methods: {
    isEven: function isEven(n) {
      return n === 0 || !!(n && !(n % 2));
    }
  }
});

/***/ }),

/***/ "onsV":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("cGkp");

$export($export.S + $export.F, 'Object', {assign: __webpack_require__("1Tda")});

/***/ }),

/***/ "p/Cb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("JyHQ"), __esModule: true };

/***/ }),

/***/ "pOAq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__("zoac");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__ = __webpack_require__("UlOv");



/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["b" /* Line */],
  data: function data() {
    return {
      datacollection: {
        labels: ['7/1/2017', '8/1/2017', '9/1/2017', '10/1/2017', '11/1/2017', '12/1/2017'],
        datasets: [{
          label: 'Real Estate',
          backgroundColor: 'rgba(51, 153, 255, 0.20)',
          borderColor: 'rgba(51, 153, 255, 0.90)',
          data: [10.03, 10.90, 10.23, 11.43, 12.21, 12.09]
        }, {
          label: 'The Market',
          backgroundColor: 'rgba(51, 153, 255, 0.20)',
          borderColor: 'rgba(51, 153, 255, 0.90)',
          data: [6.03, 6.90, 7.43, 6.95, 7.13, 8.32]
        }]
      }
    };
  },
  mounted: function mounted() {
    var vm = this;
    vm.renderChart(vm.datacollection, {
      responsive: true,
      maintainAspectRatio: false,
      legend: { display: false },
      lineTension: 0,
      tooltips: {
        callbacks: {
          title: function title(tooltipItems) {
            return '' + tooltipItems[0].xLabel;
          },
          // label: tooltipItem => `$${tooltipItem.yLabel.toLocaleString('currency')}`,
          label: function label(tooltipItem) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(tooltipItem.yLabel).toPrecision(3) + '%';
          }
        }
      },
      scales: {
        yAxes: [{
          ticks: {
            callback: function callback(value) {
              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(value).toPrecision(3) + '%';
            },
            max: 14.00,
            min: 4.00,
            stepSize: 2
          }
        }]
      }
    });
  }
});

/***/ }),

/***/ "pTwj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "q1Kv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "q79K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qHOI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{ name: 'Closed Registration' }}},[_c('Button',{class:{ 'tall-cta': _vm.tall },attrs:{"type":_vm.type,"href":_vm.loginUrl}},[_vm._v(_vm._s(_vm.title)+"\n      "),(_vm.arrow)?_c('Icon',{attrs:{"type":"arrow-right-c"}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qTrL":
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

/***/ }),

/***/ "rNVv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NestedIcon_vue__ = __webpack_require__("Vqvw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c213b530_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NestedIcon_vue__ = __webpack_require__("ZWGY");
function injectStyle (ssrContext) {
  __webpack_require__("q79K")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c213b530"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NestedIcon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c213b530_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NestedIcon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rwnw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_REvMarketCard_vue__ = __webpack_require__("xUsI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f2b3d28_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_REvMarketCard_vue__ = __webpack_require__("nsN4");
function injectStyle (ssrContext) {
  __webpack_require__("Rute")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_REvMarketCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f2b3d28_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_REvMarketCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rxWb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "s23M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sbQ8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "swmp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Row',{attrs:{"type":"flex"}},[_c('Col',{attrs:{"span":"20"}},[_c('h3',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('Col',{attrs:{"span":"4"}},[_c('Row',{attrs:{"type":"flex","align":"middle","justify":"end"}},[_c('Icon',{attrs:{"type":"more"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "t1KY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Hero',{attrs:{"title":"Vue Finance - Terms of Use","description":"","minHeight":"500px","backgroundColor":"#2c3849"}}),_vm._v(" "),_c('DenseContent',{attrs:{"content":_vm.terms}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "thJ3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: { type: String, required: true },
    type: { type: String, default: 'primary' },
    eventType: { type: String, enum: ['demo', 'introductory-call'] },
    isMobile: Boolean
  },
  methods: {
    openDemoForm: function openDemoForm() {
      // window._elev.openModule('2');
      var vm = this;
      var demoUrl = 'https://calendly.com/vue-finance/' + vm.eventType;
      if (vm.isMobile) {
        window.open(demoUrl);
      } else {
        window.Calendly.showPopupWidget(demoUrl);
      }
    }
  }
});

/***/ }),

/***/ "tnE8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "uuEf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AssessmentsPage_vue__ = __webpack_require__("SZXL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c24c4cf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AssessmentsPage_vue__ = __webpack_require__("cxo1");
function injectStyle (ssrContext) {
  __webpack_require__("Kn4X")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AssessmentsPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c24c4cf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AssessmentsPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vXbD":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("WwqW")
  , document = __webpack_require__("+rzM").document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};

/***/ }),

/***/ "vnJH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PricingPlanCard_vue__ = __webpack_require__("EYYO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30aad334_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PricingPlanCard_vue__ = __webpack_require__("/JsO");
function injectStyle (ssrContext) {
  __webpack_require__("45GK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PricingPlanCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30aad334_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PricingPlanCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vpbU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "w3Xq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: { title: String }
});

/***/ }),

/***/ "wNNh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__("zoac");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);

//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    tableData: Array,
    baseValue: Number
  },
  data: function data() {
    return {
      columns: [{ title: 'Date', key: 'label', width: '3' }, { title: 'Value', key: 'value', width: '4' }, { title: 'Growth', key: 'change', width: '3' }]
    };
  },

  methods: {
    commafy: function commafy(number) {
      return String(number).replace(/(^|[^\w.])(\d{4,})/g, function ($0, $1, $2) {
        return $1 + $2.replace(/\d(?=(?:\d\d\d)+(?!\d))/g, '$&,');
      });
    }
  },
  computed: {
    formattedTableData: function formattedTableData() {
      var vm = this;

      var fiendlyLabelsMap = {
        'A few seconds ago': 'Today',
        'A month ago': 'Last Month',
        'A year ago': 'Last Year'
      };

      // slice to limit 3 items
      return vm.tableData.slice(0, 3).map(function (row) {
        var percentGrowth = (vm.baseValue - row.value) / vm.baseValue * 100;
        var indicator = percentGrowth > 0 ? '+' : '';
        return {
          label: fiendlyLabelsMap[row.label] || row.label,
          value: '$' + vm.commafy(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(row.value).toPrecision(9)),
          change: row.value ? '' + indicator + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(percentGrowth).toPrecision(3) + '%' : 'No Data',
          cellClassName: {
            change: percentGrowth < 0 ? 'red table-bold' : 'table-green table-bold'
          }
        };
      });
    }
  }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VueFooter__ = __webpack_require__("4pYr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_VueHeader__ = __webpack_require__("QTEU");
//
//
//
//
//
//
//
//
//
//




var resizeHandler = void 0;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: { VueFooter: __WEBPACK_IMPORTED_MODULE_0__components_VueFooter__["a" /* default */], VueHeader: __WEBPACK_IMPORTED_MODULE_1__components_VueHeader__["a" /* default */] },
  computed: {
    isMobile: function isMobile() {
      return this.windowWidth <= 768;
    }
  },
  data: function data() {
    return {
      windowWidth: 1280
    };
  },

  mounted: function ready() {
    var vm = this;

    vm.windowWidth = window.innerWidth;
    resizeHandler = function resizeHandler(evnt) {
      vm.windowWidth = evnt.target.innerWidth;
    };

    window.addEventListener('resize', resizeHandler);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', resizeHandler);
  }
});

/***/ }),

/***/ "xUsI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__charts_REvMarket__ = __webpack_require__("pOAq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CardHeader__ = __webpack_require__("M9NS");
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['isMobile'],
  components: { REvMarket: __WEBPACK_IMPORTED_MODULE_0__charts_REvMarket__["a" /* default */], CardHeader: __WEBPACK_IMPORTED_MODULE_1__CardHeader__["a" /* default */] }
});

/***/ }),

/***/ "xYQJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_pages__ = __webpack_require__("f6Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Hero__ = __webpack_require__("UfZ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SectionNavigation__ = __webpack_require__("6MC7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContentImageSection__ = __webpack_require__("n6LY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DemonstrationSection__ = __webpack_require__("LmGY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EmailSignupSection__ = __webpack_require__("1itW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AggressiveCTA__ = __webpack_require__("92J2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Hero: __WEBPACK_IMPORTED_MODULE_1__Hero__["a" /* default */], SectionNavigation: __WEBPACK_IMPORTED_MODULE_2__SectionNavigation__["a" /* default */], ContentImageSection: __WEBPACK_IMPORTED_MODULE_3__ContentImageSection__["a" /* default */], DemonstrationSection: __WEBPACK_IMPORTED_MODULE_4__DemonstrationSection__["a" /* default */], EmailSignupSection: __WEBPACK_IMPORTED_MODULE_5__EmailSignupSection__["a" /* default */], AggressiveCTA: __WEBPACK_IMPORTED_MODULE_6__AggressiveCTA__["a" /* default */] },
  props: ['isMobile', 'windowWidth'],
  data: function data() {
    var content = __WEBPACK_IMPORTED_MODULE_0__services_pages__["a" /* default */].valuations;
    return { content: content };
  }
});

/***/ }),

/***/ "xeRV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SecuritySection_vue__ = __webpack_require__("q1Kv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9cb7501c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecuritySection_vue__ = __webpack_require__("JNVo");
function injectStyle (ssrContext) {
  __webpack_require__("e8hI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9cb7501c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SecuritySection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9cb7501c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecuritySection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xjCK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Hero__ = __webpack_require__("UfZ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DenseContent__ = __webpack_require__("1uhW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EmailListSignupForm__ = __webpack_require__("Hih6");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Hero: __WEBPACK_IMPORTED_MODULE_0__Hero__["a" /* default */], DenseContent: __WEBPACK_IMPORTED_MODULE_1__DenseContent__["a" /* default */], EmailListSignupForm: __WEBPACK_IMPORTED_MODULE_2__EmailListSignupForm__["a" /* default */] },
  data: function data() {
    return {
      content: [{
        title: 'Sorry! We\'ve closed public registration for Vue Finance.',
        content: ['', 'Thank you for being interested in using Vue Finance.', 'We are not accepting any new user registrations at this time. Please join our email list to be notified when we are accepting new user signups.']
      }]
    };
  }
});

/***/ }),

/***/ "xslW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Row',{staticClass:"content-section border-top",class:{
    'content-section-light': _vm.tone === 'light',
    'content-section-dark': _vm.tone === 'dark',
  },attrs:{"type":"flex","justify":"center"}},[_c('Col',{attrs:{"span":"24"}},[_c('Row',{attrs:{"type":"flex","justify":"center"}},[_c('h1',{staticClass:"content-text-title"},[_vm._v("\n        Invest in Your Financial Data\n      ")])]),_vm._v(" "),_c('Row',{attrs:{"type":"flex","justify":"center"}},[_c('h2',{staticClass:"content-text-sub-title"},[_c('strong',[_vm._v("Start building")]),_vm._v(" the metrics and reports you need to "),_c('strong',[_vm._v("achieve more with your portfolio")]),_vm._v(".\n      ")])]),_vm._v(" "),_c('Row',{staticStyle:{"margin-top":"8px"},attrs:{"type":"flex","justify":"center"}},[_c('GetStartedButton',{attrs:{"arrow":true,"tall":true,"title":"Get Started for Free!"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yvvZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Col',{style:({
    'margin-bottom': '60px',
    'min-height': _vm.minHeight,
    overflow: 'hidden',
    'background': _vm.backgroundColor || _vm.backgroundImage,
    'background-size': _vm.backgroundImage ? '100%' : undefined,
    'background-position': _vm.backgroundImage ? 'center' : undefined,
    'background-size': 'cover',
  })},[_c('Row',{staticClass:"hero large-side-margin",style:({ 'padding-top': _vm.isMobile ? '100px' : '200px' }),attrs:{"type":"flex","justify":_vm.image ? 'start' : 'space-between'}},[_c('Col',{staticClass:"pad-against-pull-up",style:({ width: _vm.contentWidth })},[_c('h1',{staticClass:"pad-content-row",class:{ 'text-shadow-img': _vm.backgroundImage, 'text-shadow': !_vm.backgroundImage && _vm.textShadow },staticStyle:{"padding-bottom":"0px"},style:(_vm.titleStyle)},[_vm._v("\n        "+_vm._s(_vm.title)+"\n      ")]),_vm._v(" "),_c('h3',{staticClass:"pad-content-row",class:{ 'text-shadow-img': _vm.backgroundImage, 'text-shadow': !_vm.backgroundImage && _vm.textShadow }},[_vm._v("\n        "+_vm._s(_vm.description)+"\n      ")]),_vm._v(" "),_c('Row',{staticClass:"pad-content-row"},[_c('GetStartedButton',{staticClass:"box-shadow"}),_vm._v(" "),_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:({ el: '#hero-clearfix', offset: _vm.scrollOffset }),expression:"{ el: '#hero-clearfix', offset: scrollOffset }"}],staticStyle:{"margin-left":"4px"},attrs:{"href":"#"}},[_c('Button',{staticClass:"box-shadow"},[_vm._v("Learn More "),_c('Icon',{attrs:{"type":"arrow-down-c"}})],1)],1)],1)],1),_vm._v(" "),_c('Col',{staticClass:"pull-up"},[_c('Row',{staticStyle:{"width":"300px"}},[_c('img',{style:({ 'max-width': _vm.maxImageWidth }),attrs:{"src":_vm.image}})])],1)],1),_vm._v(" "),(_vm.slant)?_c('Row',{style:(_vm.poly)}):_vm._e(),_vm._v(" "),_c('Row',{attrs:{"id":"hero-clearfix"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zI9j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Row',{staticClass:"asset-classes-section",attrs:{"type":"flex","justify":"center"}},[_c('Col',{attrs:{"span":"24"}},[_c('Row',{attrs:{"type":"flex","align":"middle","justify":"space-between"}},[_c('span',[_c('Icon',{staticClass:"green",attrs:{"type":"ios-checkmark-outline"}}),_vm._v(" Private Equity")],1),_vm._v(" "),_c('span',[_c('Icon',{staticClass:"green",attrs:{"type":"ios-checkmark-outline"}}),_vm._v(" Lending")],1),_vm._v(" "),_c('span',[_c('Icon',{staticClass:"green",attrs:{"type":"ios-checkmark-outline"}}),_vm._v(" Real Estate")],1),_vm._v(" "),_c('span',[_c('Icon',{staticClass:"green",attrs:{"type":"ios-checkmark-outline"}}),_vm._v(" Personal Property")],1),_vm._v(" "),_c('span',[_c('Icon',{staticClass:"green",attrs:{"type":"ios-checkmark-outline"}}),_vm._v(" Currencies")],1),_vm._v(" "),_c('span',[_c('Icon',{staticClass:"green",attrs:{"type":"ios-checkmark-outline"}}),_vm._v(" Marketable Securities")],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zoac":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("NE1x"), __esModule: true };

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.db3216c1837163f53ed9.js